export default {
  navbar_pages: {
    stats: 'Статистика',
    settings: 'Настройки',
    team: 'Команда',
    menu: 'Меню',
    interfaces: 'Интерфейсы',
    systems: 'Системы',
    forms: 'Формы',
    integrations: 'Интеграции',
    profile: 'Профиль',
    sms: 'SMS',

    systems_connected: 'Подключено',
    systems_available: 'Доступно',

    orders_panel: 'Панель заказов',
    admin_panel: 'Админ панель',

    telegram: 'Telegram',
    mobile_app: 'Mobile App',

    workspace: 'Заведения',
    workspace_add: 'Добавить заведение',

    marketing: 'Маркетинг',
    marketplace: 'Маркетплейс',
  },
  navbar: {
    quickstart: 'Начало работы',
    cafe: 'Главная',
    dashboard: 'Заведение',
    general: 'Общее',
    stats: 'Статистика',
    menus: 'Редактор меню',
    delivery: 'Delivery',
    preorder: 'Takeaway',
    inside: 'Inside',
    inside_lite: 'INSIDE lite',
    preview: 'Preview',
    reserve: 'Table booking',
    reserve_new: 'Reserve',
    cafe_settings: 'Настройки',
    settings: 'Аккаунт',
    tools: 'Инструменты',
    marketing: 'Маркетинг',
    top_integrations: 'Интеграции',
    pos_integrations: 'POS-интеграции',
    integrations: 'Marketplace',
    stats: 'Статистика',
    reviews: 'Отзывы',
    rooms: 'Номера',
    workers: 'Персонал',
    loyalty: 'Программа лояльности',
    discounts: 'Акции',
    subscriptions: 'Платежи',
    marketplace: 'Marketplace QR',
    help: 'Скачать инструкцию',
    logout: 'Выход',
    billing: 'Оплата',
    setup: 'Как настроить систему?',
    qrstore: 'Системы QRWaiter',
    systems: 'QRStore',
    halls: 'Залы и столы',
    notifications: 'Уведомления',
    clients_base: 'Клиентская база',
    online_payment: 'Онлайн оплата',
    hotels: 'ROOMS',
    orders_panel: 'Панель заказов',
    client_orders_history: 'История заказов',
    balance: 'Баланс',
    balance_table: 'История транзакций',
    sms_settings: 'Настройки SMS',
    checklists_reports: 'Отчеты',
    working_schedule: 'График работы',
    tips_settings: 'Чаевые',

    stickers_gallery: 'Галерея стикеров',

    nomenculature_packaging: 'Упаковка',
    checklists: 'Чек-листы',

    chain_cafes: 'Заведения',
    chain_settings: 'Сеть',

    sms_history: 'История SMS',

    stats_orders: 'Общая статистика',
    stats_guests: 'Гости',
    stats_finances: 'Финансы',
    stats_tables: 'Залы и столы',
    stats_average: 'Средний чек',

    //corporate admin panel
    corporate_cafes: 'Мои заведения',
    corporate_users: 'Доступ',
    corporate_stats: 'Статистика',

    chain: 'Сеть заведений',
    switch_cafe: 'Сменить заведение',

    taxes: 'Налоги',

    support: 'Тех. поддержка',

    menu_app: 'Приложение с меню',
    client_app: 'Настройки',
    language: 'Язык',

    systems_in_your_plan: 'В вашем тарифе',
    systems_extra: 'Дополнительно',
  },
  navigation: {
    back: 'Назад',
  },
  confirm_register: {
    text: 'Для создания аккаунта придумайте надежный пароль входа.',
    password: 'Новий пароль:',
    continue: 'Далее',
    repeat_password: 'Повторите новый пароль:',

    success: 'Ваш аккаунт создан. Теперь Вы можете войти. Переадресация...',
    error: 'Ошибка:',

    pass_strength: {
      title: `Надежность пароля`,
      '0': 'Отсутствует',
      '1': 'Ненадежный',
      '2': 'Средняя',
      '3': 'Надежный',
      '4': 'Очень надежный',
    },

    init_errors: {
      not_found: 'Неправильная или уже использованая ссылка.',
      expired:
        'Срок действия ссылки закончился. Пожалуйста, отправьте новую заявку на регистрацию.',
    },

    errors: {
      weak: 'Пароль недостаточно надежен.',
      mismatch: 'Ваши пароли не совпадают.',
    },

    title: 'Подтверждение регистрации',
    create_password: 'Создайте пароль для аккаунта:',
    repeat_password: 'Повторите новый пароль:',
    create_acccount: 'Создать аккаунт',
  },
  confirm_employee: {
    desc:
      'Чтобы активировать аккаунт, придумайте надежный (от 6 символов) пароль',
    pass: 'Введите пароль',
    repeat: 'Повторите новый пароль',
    btn: 'Активировать аккаунт',
    title: 'Подтверждение приглашения',
    hint: 'Создайте пароль для Вашего аккаунта QRWaiter',
  },
  login: {
    email: 'Введите Вашу электронную почту',
    password: 'Введите Ваш пароль',
    forgot: 'Забыли пароль?',
    register: 'Регистрация',
    title: 'Авторизация',

    two_factor_confirm:
      'На Ваш номер телефона {phone_mask} был отправлен одноразовый 6-значный код подтверждения.',

    login: 'Войти',

    via_email: 'Через email',
    via_code: 'По коду',

    code_hint: 'Вы можете войти с помощью Telegram бота',
    code_get: 'Нажмите "Получить код для входа" в',
  },
  menu_manager: {
    title: 'Список меню',

    add_menu: '+ Добавить меню',
    add_menu_ph: 'Название нового меню',

    last_edited: 'Последнее редактирование было',
  },

  menus: {
    title: 'Редактор меню',
  },
  poptop: {
    title: `Пополнить счет`,
    sum: `Сумма пополнения`,
    hint: `300 грн`,
    input: `Ввести сумму`,
    hintb: `500 грн`,
    pay: `Оплатить`,
    back: `Вернуться`,
  },

  menu_settings: {
    title: 'Настройки меню',
    name: `Название`,
    name_hint: `Это техническое название меню для Вас, и оно не показывается клиенту.`,
    price: `Цена`,
    weight: `Вес`,
    volume: `Объем`,
    portions_goods: `Порция`,
    weight_goods: `Весовой товар`,
    semi_weight_goods: 'Весовая порция',

    portion_desc: 'При заказе указывается количество порций.',
    weight_desc:
      'При заказе указывается общий вес блюда, а не количество порций.',
    semi_weight_desc:
      'При заказе указывается количество порций, но вес каждой порции можно отредактировать при принятии заказа',

    non_excise_goods: `Неакцизний товар`,
    add_ingredients: `Добавить ингредиент`,
    input_ingredients: `Перечислите ингредиенты (они не показываются гостям в онлайн меню, а нужны для работы алгоритма смарт рекомендаций и для того, чтобы отфильтровать аллергенные блюда для того или иного гостя)`,
    excise_goods: `Акцизный товар`,
    about: `Описание блюда`,
    convert: `Конвертировать описание в ингредиенты`,
    edit: 'Редактировать выбранное меню',
    edit_name: 'Редактировать название',
    save_name: 'Сохранить название',
    duplicate: 'Дублировать',
    delete: 'Удалить',
    done: `Готово`,
    hint: `Главное - сезон 2020`,
    hintb: `Бар меню`,
    webmenu: `Это название будет показываться клиенту в онлайн меню.`,
    will_delete: `Выбранное дополнение будет удалено из всех блюд, в которых они есть. Вы уверены?`,
    sale_hint: `Скидка на все меню`,
    sale_hintb: `Скидка будет применена на все блюда и напитки в этом меню.`,
    preview: `Отсканируйте QR-код чтобы просматривать меню в реальном времени, пока Вы его редактируете.`,
    poster: `Это меню импортировано из системы Poster и не может быть удалено или дублировано через редактор меню. Чтобы удалить это меню, Вам необходимо отключить интеграцию с системой Poster.`,
    sale: `Скидка`,
    recomendations: `Рекомендации`,
    additions: `Дополнения`,
    addition: `Дополнение`,
    ingredients: `Ингредиенты`,
    variants: `Варианты`,
    DELETE: `УДАЛИТЬ`,
    import_poster: `Импортировать блюдо из Poster`,
    in_poster: `Соответствующий товар в системе Poster`,
    poster_locked:
      'Это блюдо было импортировано из системы Poster. Изменить цены или модификаторы можно только в Poster.',
    show_exclusives: 'Рекомендации в меню',
    show_exclusives_desc:
      'Отдельная категория рекомендаций, в которой отображаются самые популярные блюда. Эту категорию также можно настроить вручную.',

    modes: {
      inside: 'Заказ внутри заведения при помощи QR-кодов',
      preorder:
        'Клиенты получат возможность сделать заказ заранее на определенную дату и время, перейдя по ссылке.',
      delivery:
        'Клиенты могут заказать заранее с доставкой по указанному адресу и указанное время.',
    },
    duplicate_suffix: '(копия)',

    confirm_delete_title: 'Удаление меню',
    confirm_delete: 'Вы уверены, что хотите удалить меню "{title}"?',
    cannot_reverse: 'Восстановить удаленное меню будет невозможно.',
    example_menu: 'Пример заполненого меню',

    select_mode: 'Выберите, в каких системах должно работать данное меню',
    no_modes:
      'Ни одна система у Вас не включена. Для активации системы, перейдите в раздел "Системы QRWaiter"',
    preview_title: 'Предпросмотр меню',

    systems: 'Системы',
  },

  menu_tag: {
    title: 'Название меню для гостей',
    ph: 'Бар меню',
    desc:
      'Когда у вас для одной системы включено несколько разных меню, то гости могут между ними переключатся. Укажите название, которое будут видеть Ваши гости (например, "Бар меню")',
  },

  menu_editor: {
    back: 'Назад',
    variants: `Перечислите варианты`,
    new_variant: `Новый вариант`,
    variant: `Вариант`,
    gram: `Грамаж`,
    liter: `Литраж`,
    price: `Цена`,
    additions: `Перечислите дополнения`,
    addition: `Дополнение`,
    new_addition: `Новое дополнение`,
    languages: 'Доступные языки:',
    confirm_language_delete: 'Вы уверены, что хотите удалить этот язык меню?',
  },

  menu_content_type: {
    title: 'Тип меню',
    dishes: 'Блюда',
    drinks: 'Напитки',
    description:
      'В зависимости от выбранного типа на блюдах будут менятся единицы измерения (граммы или литры)',
  },

  menu_payment: {
    title: 'Счет для онлайн оплаты',
    choose_ph: '- выберите счет -',
    warning:
      'Оплата онлайн в этом меню недоступна. Пожалуйста, выберите счет для оплаты.',
    desc:
      'Выберите счет, на который будут начисяться средства за оплату заказов с этого меню.',
  },

  category_list: {
    title: 'Категории',

    add_category: '+ Добавить категорию',
    add_category_ph: 'Название категории',

    new_category_ph: 'Новая категория',

    edit: 'Редактировать',
    rearrange: 'Сортировать',
    done: 'Готово',

    delete: 'Удалить категорию',
    confirm_delete:
      'Вы уверены, что хотите удалить категорию "{name}"? Это действие удалит все блюда, имеющиеся в этой категории.',
  },

  dish_list: {
    title: 'Блюда',
    add_dish: '+ Добавить блюдо',
    out_of_stock: 'Не в наличии',

    rearrange: 'Сортировать',
    availability: 'Наличие',

    invalid_dish: `Не заполнены обьязательные поля`,
  },

  dish_tab: {
    title: 'Блюдо',

    edit: 'Редактировать',
    delete: 'Удалить',
    done: 'Готово',

    confirm_delete_title: 'Удаление блюда',
    confirm_delete: 'Вы уверены, что хотите удалить блюдо "{name}"?',
  },

  dish_settings: {
    title: 'Настройки блюда',
    excise_desc:
      'Укажите, является ли товар акцизным. Акцизные товары не показываются в меню лицам младше 18 лет.',
    weighted_desc:
      'От этой опции зависит как будет вычислятся стоимость упаковки.',
    stock_disabled:
      'Вы не можете изменить наличие этого блюда, поскольку включена синхронизация остатков на складах с POS-системой.',
    in_stock: 'Товар в наличии',
    preset: 'Тип',
    preset_desc:
      'Для ускорения ввода меню Вы можете выбрать тип блюда и нужные модификаторы будут созданы автоматически.',
    preset_dish: 'Обычное блюдо',
    preset_pizza: 'Пицца',
    waiting_time_ph: 'Приблизительное время приготовления (мин)',

    limits: 'Ограничения',
    weight_type: 'Тип взвешивания',

    sync_warn:
      'Это меню было отредактировано на другом устройстве.<br>Пожалуйста, при редактировaнии меню, работайте в одной вкладке и не дублируйте их.',

    long_units: {
      l: 'Литры',
      g: 'Граммы',
      cm: 'Сантиметры',
      kg: 'Килограммы',
      ml: 'Милилитры',
    },

    status_saved: 'Изменения сохранены.',
    status_saving: 'Сохранение изменений...',
    status_error: `Блюдо не отображается в меню, поскольку такие обьязательные поля как название или цена не заполнены.`,

    enable_modes_description:
      'Выберите, в каких системах должно отображаться это блюдо.',

    service_duration: 'Длительность обслуживания',
    service_break_time: 'Время перерыва',
  },

  transfer_dish: {
    title: 'Перемещение блюда',
    action: 'Переместить',
    select_menu: 'выберите меню',
    select_category: 'выберите категорию',
    cancel: 'Отменить',
    confirm: 'Переместить',
  },

  modificators_settings: {
    title: 'Настройки модификаторов',
    variant_name: 'Варианты',
    modif_name: 'Дополнения',
    type_hint: 'Тип',
    selection_hint: 'Мультивыбор',
    name_hint: 'Название набора модификаторов',
    placeholder_optional: 'Вы можете оставить это поле пустым',
    placeholder_required: 'Введите название для набора',
    single_select: 'Гость может выбрать только 1 вариант из списка',
    multi_select: 'Гость может выбрать несколько вариантов из списка',
    single_select_limited: 'Выбор до {max_count} вариантов из списка',
    multi_select_limited: 'Выбор до {max_count} дополнений из списка',

    item_placeholder: 'Название модификатора',
    placeholder_dish: 'Название модификатора',
    placeholder_pizza: 'Размер пиццы (см)',

    dependencies_title: 'Зависимости',
    dependencies_btn: 'Настроить зависимости',
    visible: 'Видимый',

    group: 'Группа модификаторов',

    name_ph: 'Модификатор',

    integration: 'Интеграция',

    locked_changes: 'Изменения заблокированы',

    link_btn: `Связать с другим набором`,

    max_count_variants_hint: 'Выбор нескольких модификаторов',
    max_count_additions_hint:
      'Ограничить максимальное количество модификаторов для выбора',

    allow_max_count: 'Разрешать выбирать несколько вариантов',
    max_count_placeholder: 'Укажите максимальное количество',

    confirm_remove: 'Вы уверены что хотите удалить этот набор модификаторов?',
    confirm_remove_item: 'Вы уверены, что хотите удалить этот модификатор?',

    add_modificator: 'Добавить модификатор',
    add_group: 'Добавить набор модификаторов',
    remove_group: 'Удалить набор модификаторов',

    dependencies_info_tip:
      'Вы можете привязать эту группу к выбраным модификаторам другой группы.',

    dependency_self_item:
      'Вы можете привязать этот модификатор к другой группе модификаторов. Она будет показана если будет выбран этот модификатор.',

    move_up: 'Переместить вверх',
    move_down: 'Переместить вниз',

    manage: 'Изменить',
    setup: 'Настроить',

    linked_tip_title: 'Привязанная зависимость',
    linked_tip_desc:
      'Эта группа модификаторов привязана к другому модификатору. Это означает, что она будет показана только в том случае, если будет выбран один из следующих модификаторов:',

    cant_delete_group:
      'Эта группа модификаторов являеться обязательной в POS системе и необходима для корректной работы интеграции, поэтому ее настройки нельзя изменять.',
  },

  add_modificator_group_modal: {
    add_new: 'Создать новый набор модификаторов',
    add_existing: 'Добавить существующий набор',
    add_existing_desc: 'Выберите набор из списка, который Вы желаете добавить.',
    merge: 'Привязать',
    confirm: 'Добавить набор',
    cancel: 'Отменить',
    select_ph: 'Выберите набор',
  },

  modificators_merge_modal: {
    title: 'Привязка набора модификаторов',
    info1:
      'Вы можете построить зависимость между группами модификаторов. При выборе определенного модификатора в одной группе, гость будет видеть этот набор модификаторов.',
    info2:
      'Выберите модификатор, к которому должна быть привязана данная группа модификаторов',
    group_ph: 'Группа модификаторов',
    mod_ph: 'Модификатор',
  },

  confirm_modal: {
    confirm: 'Да',
    cancel: 'Нет',
    default: 'Вы уверены?',
  },

  image_uploader: {
    default: 'ЗАГРУЗИТЬ',
    edit: 'РЕДАКТИРОВАТЬ',
    delete: 'УДАЛИТЬ',

    default_busy: 'ПОДОЖДИТЕ...',

    type_logo: 'Логотип',
    type_cover: 'Обложка',

    size: 'Размер',
    format: 'Формат',
  },

  schedule: {
    days: {
      mon: 'Понедельник',
      tue: 'Вторник',
      wed: 'Среда',
      thu: 'Четверг',
      fri: `Пятница`,
      sat: `Суббота`,
      sun: 'Воскресенье',
    },

    general_title: 'Общий график работы',
    general_desc:
      'Этот график работы будет применяться ко всем системам по умолчанию',

    specific_title: 'График работы {mode}',
    specific_desc:
      'Эти настройки будут использоваться вместо общего графика работы',

    mode_title: 'Индивидуальный график работы',
    menu_title: 'Индивидуальный график работы меню',

    from: 'От',
    to: 'До',

    mode_desc:
      'Если этот параметр выключен, то система {mode} работает согласно общему графику заведения. Вы можете настроить для нее индивидуальный график работы, который не будет зависеть от общего.',

    using_default:
      'Для этой системы используется общий график работы заведения',

    menu_text:
      'Вы можете настроить график работы меню. Например, если Ваше заведение работает до 23:00, а кухня только до 21:00.',
  },

  nouns: {
    dishes: 'блюд',
    categories: 'категорий',
    modificators: 'дополнений',
  },
  units: {
    units: `Единица измерения`,
    l: 'л.',
    g: 'г.',
    ml: 'мл.',
    mins: 'мин.',
    kg: 'кг.',
    hours: 'ч.',
    cm: 'см.',
    meters: 'м.',
    days: 'дн.',
    tariffs: 'тариф | тарифа',
  },
  error_codes: {
    subscription_form_failed: 'Не удалось сгенерировать форму оплаты. ',
    cafe_save: `Не удалось сохранить настройки заведения. Пожалуйста, повторите попытку или свяжитесь с тех. поддержкой.`,
    menu_save: `Не удалось сохранить меню. `,
    promocode_wrong: 'Промокод неверен.',
    packaging_empty: 'Укажите хотя бы 1 настройку упаковки.',
    warehouses_error:
      'Не удалось загрузить список доступных отделений "Новая Почта". Пожалуйста, обновите страницу или свяжитесь с тех. поддержкой.',
    shipment_failed: 'Не удалось разместить Ваш заказ.',
    billing_fetch: 'Не удалось загрузить информацию о балансе.',
    stats_failed: 'Не удалось загрузить статистику. ',
    poster_error: `Ошибка интеграции с системой Poster. Пожалуйста, свяжитесь с тех. поддержкой.`,
    reviews_error: 'Ошибка загрузки отзывов. ',
    subscription_error: 'Ошибка загрузки подписок. ',
    menu_sync:
      'Необходима синхронизация меню - подождите, пожалуйста, страница будет перезагружена...',
    referrals_error: 'Ошибка загрузки данных о маркетинге. ',

    auth_error: 'Ошибка авторизации. ',
    menu_invalid: `Для сохранения меню необихдно заполнить все обязательные поля, такие как названия и цены`,
    subscription_setup_mode:
      'Для оформления подписки необходимо полностью настроить выбранную систему.',

    currency_error: 'Произошла ошибка загрузки данных о валюте. ',
    menu_schedule:
      'График работы меню не должен выходить за рамки графика работы заведения.',

    reserve_tables:
      'Для сохранения настроек залов и столов RESERVE, выберите хотя бы 1 стол в роли стола для бронирований.',
    payment_error: 'Ошибка сервиса онлайн оплаты. ',
    superbilling_errror: 'Ошибка сервиса оплаты.',

    promocodes_error: 'Ошибка системы промокодов. ',
    waiter_pin_exists:
      'Официант с таким ПИН кодом уже существует. Пожалуйтса, измените ПИН код.',
  },

  order_stickers: {
    templates: {
      basic: 'Современный',
      classic: 'Классический',
      hype: 'Молодежный',
    },
  },

  mode_settings: {
    enable: 'Система',
    menu: 'Меню',
    payment: 'Способы оплаты',
    waiters: 'Персонал',
    stickers: 'Cтикеры',
    schedule: 'График работы',
    tables: 'Залы и столы',
    subscription: 'Подписка',
    geolocation: 'Зоны доставки',
    notifications: 'Оповещения',
    address: 'Адрес заведения',
    total: '',

    required: 'Обязательные настройки',
    optional: 'Дополнительные настройки',
  },
  mode_settings_hints: {
    enable: 'Включите эту систему',
    menu: 'Включите эту систему хотя бы для одного меню',
    payment: 'Настройте доступные методы оплаты для этой системы',
    waiters: 'Настройте список персонала для приема заказов',
    stickers: 'Активируйте стикеры с QR-кодами',
    schedule: 'Настройте график работы заведения',
    tables: 'Настройте залы и столы',
    subscription: 'Оформите подписку для этой системы',
    geolocation: 'Укажите зоны, где работает Ваша доставка',
    notifications: 'Авторизируйтесь в очереди заказов.',
    address: 'Укажите корректный адрес заведения.',
    total: '',
  },
  stats: {
    title: `Статистика`,
    loading: `Загрузка...`,
    empty_desc:
      'Здесь будет статистика по Вашему заведению. Для формирования статистики, Ваше заведение должно проработать в системе QRWaiter не менее 1 недели.',
    general: `Общая`,
    currency: {
      uah: `UAH`,
      uahn: `грн`,
    },
    clients: {
      title: `Клиентская база`,
      search: `Поиск...`,
      export: `Экспортировать`,
      import: `Импортировать`,
      name: `Имя`,
      phone: `Номер телефона`,
      address: `Адрес`,
      bonus: `Бонусный счет`,
      averange: `Средний чек`,
      first: `Заказали впервые:`,
      returning: `Заказали повторно:`,
      new: `Новые`,
      old: `Старые`,
      choose_file_type: 'Выберите тип файла для экспорта:',
    },
    import: {
      file: `Выберите файл для импорта базы клиентов.`,
      csv: `Поддерживается формат CSV.`,
      max_size: `Максимальный размер файла: 3 МБ`,
      must_consist_of: `Файл должен состоять из трех столбцов: Name, Phone и Address.`,
      example: `Посмотреть пример файла для импорта.`,
      unable_to_import: `Не удалось импортировать файл клиентской базы. Убедитесь, что файл правильного формата.`,
      choose: `Выбрать файл...`,
      close: `Закрыть`,
    },
    top_dishes: 'Топ блюд',
    top_waiters: 'Топ официантов',
    top_clients: 'Топ клиентов',
    since: `since last month`,
    income_month: `Прибыль мес.`,
    averange: `Средний чек`,
    orders_month: `Заказ мес.`,
    orders: `заказов`,
    rate: `Соотношение систем`,
    data_for: `Данные за`,
    income: `Прибыль`,
    income_for: `Доход за период`,
    averange_for: `Средний чек за период`,
    orders_for: `Заказов за период`,
    visits_for: `Посещений за период`,
    views: `Просмотры меню`,
    view: `Просмотры`,
    order: `Заказов`,
    amount: `шт.`,
    popular: `Самые популярные блюда`,
    activity: `Активность`,
    guests: `Гости`,
    week: `неделю `,
    two_weeks: `2 недели `,
    month: `месяц `,
  },
  general: {
    cafe: {
      about: `Описание заведения`,
      address: `адрес:`,
      price_policy: `Ценовая политика:`,
      panelid: `ID Панели:`,
      menu: 'Меню',
      panel: `Панель заказов:`,
      settings: `Настройки`,
      no_subscriptions:
        'Здесь будут показываться активные подписки, однако сейчас ни одна из систем QRWaiter не включена.',
    },
    balance: {
      marketadd: `Пополнить`,
      marketsettings: `Настройки`,
    },
    cards: {
      inside_about_pro: `Цифровое меню внутри заведения с возможностью принимать заказы через него.`,
      inside_about: `Цифровое меню внутри заведения`,
      preorder_about: `Принимайте заказ еды "с собой".`,
      delivery_about: `Принимайте заказы на доставку.`,
      reserve_about: `Принимайте заказы на бронирование столика.`,
      deposit: `- возможность внести депозит (онлайн)`,
      hotels_about:
        'Система для отелей, которая позволит оцифровать заказы еды, напитков и даже услуг рум-сервиса.',
      info_reserve: `- можилвисть оставить подробную информацию о госте`,
      marketplace_about: `Вы также можете принимать заказы и увеличивать свою клиентскую базу используя маркетплейс QRWaiter.`,
      marketplace_settings: `Выберите системы, которые Вы хотите отображать на маркетплейсе:`,
      menu: `+ Цифровое меню для гостей`,
      pt1: `- онлайн оплата`,
      pt2: `- возможность оставить чаевые`,
      pt3: `- услуги`,
      pt4: `- мультиязычность`,
      pt5: `- смарт-рекомендации`,
      application: `+ Приложение приема заказов для персонала`,
      pro_pt1: `- Live CRM`,
      pro_pt2: `- Автоматические напоминания`,
      pro_pt3: `- Трекеры времени`,
      pro_pt4: `- Персональный кабинет для каждого работника`,
      qr: `Для использования необходимо заказать QR-стикеры.`,
      link: `Для системы используется ссылка на онлайн-меню. Ссылки можно разместить в соц. сетях.`,
      disconnect: `Отключить`,
      connect: `Подключить`,
      settings: `Настройки`,
      month: 'мес.',
    },
    daily_summary: {
      new_clients: 'Новых клиентов за последний месяц',
      new_orders: 'Заказов за последний месяц',
    },
  },
  marketplace: {
    bonus_hint: `Вы можете давать своим гостям бонусы от заказов в Вашем заведении. Как только гость накопит достаточно бонусов - он сможет ими рассчитаться за заказ. А Вы и Ваш персонал будут уведомлены про "бонусный рассчет"`,
    bonus_amount: `Укажите размер бонуса`,
    loyalty_program: `Используя программу лояльности Вы автоматически соглашаетесь с политикой маркетплейса QRWaiter.`,
    no_bonus: `Выберите размер бонуса`,
    loyalty: `Программа лояльности`,
    add_balance: `Пополнить`,
    remind_on_low: `Напоминать о пополнении при балансе меньше`,
    flavors_title: 'Категории заведения',
    balance_title: 'Баланс',
    balance_debt:
      'Допустимий баланс -30 грн. При превышении лимита Ваше заведение не будет отображаться в маркетплейсе QRWaiter.',
    policy_agree:
      'Выбирая хотя бы одну из систем, Вы автомаически соглашаетесь с политикой маркетплейса QRWaiter.',
    flavors_desc:
      'Выберите, к каким категорям принадлежит Ваше заведение. Помните, что сортировка заведений в маркетплейсе по категориям помогает Вашим гостям быстрее найти нужное заведение.',
    flavors_one:
      'Заведение будет отображатся в маркетплейсе только после того как будет выбрана хотя бы 1 категория.',
    flavors_not_found:
      'Если Вы не смогли найти подходящей категории для Вашего заведения - обратитесь к',
    flavors_support: 'тех. поддержке QRWaiter.',
    app_desc:
      'Отсканируйте QR-код с мобильного устройства (через камеру) либо нажмите на иконку магазина приложений, чтобы загрузить наше приложение.',
    land_title: 'Получайте еще больше заказов с помощью маркетплейса QRWaiter™',
    land_connect: 'Подать заявку',
    download_btn: 'Загрузить приложение',
  },
  marketplace_policy: {
    title: 'Политика маркетплейса QR',
    agreed: 'Я прочитал и согласен',
    agreed_link: 'с политикой маркетплейса QR',
    link:
      'Для того, чтобы Ваше заведение отображалось в маркетплейсе, Вам нужно согласиться с его политиикой.',
  },
  settings_cafe: {
    title: `Общие настройки заведения`,
    demo_warning:
      '! Ссылка работает в демо-режиме. Заказы не учитываются в статистику. Чтобы отключить демо режим, оплатите подписку !',
    cafe_info: {
      info: `Общая информация`,
      name: `Название заведения`,
      type: `Описание заведения`,
      price_policy: `Ценовая политика`,
      option: `--- Выберите опцию ---`,
    },
    contacts: {
      title: `Контакты заведения в меню`,
      phone: `Номер телефона`,
      address: `Адрес заведения`,
      desc:
        'Вы можете разместить контакты заведения. Ваши гости смогуть увидеть их в меню.',
    },
    online_menu: {
      title: `Ссылка на онлайн меню`,
      chain_title: 'Ссылка сети',
      copy_btn: 'Копировать ссылку',
      description:
        'Эту ссылку Вы можете разместить в своих соц. сетях. За этой ссылкой работает функционал систем TAKEAWAY, DELIVERY, RESERVE.',
      input_link: `Укажите ссылку, по которой можно будет найти Ваше онлайн-меню. Также Вы можете использовать эту ссылку в Ваших соц. сетях.`,
      input_hint: `Ссылка может содержать строчные буквы латинского алфавита, цифры и подчеркивания (_).`,
      tab_domain: 'Собственный домен',
      connect_domain: 'Проверить и подключить',
      domain_ip_text:
        'Вам нужно указать в настройках личного кабинета Вашего доменного регистратора DNS-запись типа "А" с IP-адресом нашего сервера: <span class="bold black-4-color">142.93.162.32</span>',
      domain_connect_text:
        'Изменения в DNS записях вступят в силу напротяжении 12 часов. После внесения изменений нажмите кнопку "Проверить и подключить". Если появится зеленая галочка - Ваше меню будет доступно за указанным доменом. SSL-сертификат (поддержку https) будет подключено напротяжении нескольких часов после подключения домена',
    },
    liqpay: {
      title: `Онлайн оплата`,
      human: `Карта физ. лица`,
      human_explain: `Укажите номер карты, на которую будут поступать средства за заказ:`,
      company: `Счет юр. лица`,
      company_explain: `Укажите данные расчетного счета, на который будут поступать средства за заказ:`,
      company_account_number: `Номер счета`,
      company_mfo: `МФО`,
      company_edrpoy: `ЕДРПОУ`,
      company_name: `Название компании`,
      company_tax: 'ИПН',
      company_email: 'Электронная почта',
      liqpay_account: `LiqPay`,
      liqpay_api_explain: `Укажите ключи API от Вашего аккаунта Liqpay, чтобы оплата онлайн осуществлялась напрямую на Ваш счет Liqpay:`,
      liqpay_api_pubkey: `Публичный ключ API`,
      liqpay_api_privkey: `Приватний ключ API`,
      liqpay_no_account: `Не имеете аккаунта Liqpay?`,

      liqpay_comment:
        'Комиссия составяляет 2,75%, для регистрации нужно иметь открытый счет в ПриватБанке',
      wayforpay_comment:
        'Комиссия составляет 2,5%, для регистрации подойдет счет украинского банка',

      wayforpay_account: 'Wayforpay',
      wayforpay_explain:
        'Укажите реквизиты мерчанта Wayforpay, чтобы онлайн оплата проводилась напрямую на Ваш счет:',
      wayforpay_account_ph: 'Имя мерчанта',
      wayforpay_secret_ph: 'Секретный ключ мерчанта',
      wayforpay_register: 'Зарегистрировать мерчанта Wayforpay',
      register: `Регистрация`,
      data_is_protected: `Ваши банковские данные надежно защищены и не передаются третьим лицам`,
      confirm_tip: 'После регистрации не забудьте активировать аккаунт и',
      apple_pay_tip: 'включить оплату через Apple Pay',

      stripe_explain:
        'Для приема платежей через систему Stripe, нажмите на кнопку и настройте аккаунт.',
      stripe_active: 'Покдлючен аккаунт Stripe.',
      stripe_open_btn: 'Открыть настройки Stripe',

      no_account: 'Нет аккаунта?',
      register_it: 'Зарегистрируйте его',
      comission: 'комиссия',
      choose_gateway: 'Выберите платежную систему:',

      add_receiver: 'Добавить счет',
      cancel_btn: 'Отмена',
      description_ph: 'Название счета',

      empty_list:
        'Добавтье счет платежной системы, чтобы принимать оплату за заказы онлайн.',

      liqpay_register_condition: 'только для клиентов Приватбанка',
      confirm_remove:
        'Вы уверены, что хотите удалить этот счет для онлайн оплаты?',
    },
    currency: {
      title: 'Валюта',
      desc: 'Выберите валюту Вашего заведения:',
    },
    timezone: {
      title: 'Часовий пояс',
      desc: 'Укажите часовой пояс Вашего заведения',
    },
    social: {
      title: 'Соц. сети заведения',
      desc:
        'Вы можете разместить ссылки на соц. сети заведения, для того чтобы Ваши гости могли подписаться на них.',
      instagram: 'Ссылка на Instagram',
      facebook: 'Ссылка на Facebook',
      website: 'Веб-сайт заведения',
    },
  },
  subscription: {
    title_active: 'Активные подписки',
    title: 'Подписки',
    inactive: `Неактивная`,
    active_until: `Активная до`,
    paid_until: `Оплачена до`,
    trial_period_until: 'Пробный период до:',
    ended: `Закончилась`,
    renew: `Восстановить`,
    cancl: `Отменить`,
    subscribe: `Оформить подписку`,
    cancel: `Вы уверены, что хотите отменить подписку на выбранную систему?`,
    transactions: {
      title: `История платежей`,
      number: `# платежа`,
      date: `Дата`,
      time: `Время`,
      system: `Система`,
      method: `Метод оплаты`,
      sum: `Сумма`,
      commission: 'Комиссия',
      balance: `Баланс`,
      status: `Статус`,
      reversed: 'Возвращен',
      success: `Успешно`,
      error: `Ошибка`,
      cash: `Наличка`,
      terminal: `Терминал`,
      online: `Онлайн`,
    },
    promo: {
      title: `Промокод`,
      input: `Укажите промокод для получения дополнительных услуг бонусов, если он у Вас есть.`,
      input_hint: `Введите промокод`,
      connect: `Подключить`,
    },
    active_system_cancel:
      'Для этой системы у Вас есть активная подписка. Желаете ее отменить?',
  },
  workers: {
    title: `Персонал`,
    workers_editor: {
      title: `Официанты`,
      name: `Имя`,
      pin: `PIN-код`,
      hint: `Добавьте официантов и укажите для них PIN коды.`,
      add: `+ Добавить официанта`,
    },
    workers_queue: {
      title: `Панель заказов`,
      id: `ID Панели заказов:`,
      link: `Ссылка на вход в панель заказов: `,
      version: 'Веб-версия для планшетов и ПК',
      explain: `Ваши официанты переходят по ссылке и вводят установленный для них PIN-код.`,
    },
    notifications: {
      title: `Оповещения`,
      about: `Получайте уведомления о новом заказе мгновенно с помощью Telegram бота.`,
      pt0: `Для подключения Telegram уведомлений:`,
      pt1: `1. Создайте чат с ботом`,
      pt2: `2. Напишите команду`,
      pt3: `3. Введите ID Вашего заведения -`,
      pt4: `4. Добавьте всех работников, кто должен принимать заказы.`,
      users_count: 'Сейчас в чате с ботом {n} учасник(-а)',
    },
    mobile_app: {
      ios: 'Приложение для iOS',
      title: `Мобильное приложение`,
      explain: `Загрузите приложение для приема и управления заказами.`,
      qr: `Отсканируйте QR-код с мобильного устройства (через камеру) или нажмите на иконку App Store`,
    },
    admin_bot: {
      title: `Бот для администратора`,
      explain: `Подключите QRWaiter Business Bot, чтобы получать важные уведомления та учетность по заведению`,
      authcode: `Код для авторизации:`,
      scan: 'Просканируйте этот QR-код, чтобы подключить Telegram бота.',
    },
    guide: {
      title: 'Инструкция',
      description:
        'Эта инструкция поможет вашим работникам начать работу с панелью заказов.',
      button: 'Загрузить инструкцию',
    },
  },
  inside: {
    test_button: 'Тестовый заказ',
    test_tooltip:
      'Отсканируйте этот QR-код чтобы просмотреть меню и сделать тестовый заказ',
    services: {
      title: `Услуги`,
      input_hint: `Укажите дополнительные услуги, которые гость заведения может заказать.`,
      service_name: `Название услуги`,
      add: `Добавить услугу`,
    },
    geolocation: {
      title: `Геолокация`,
      switcher_optional: `Необязательная`,
      switcher_required: `Обязательная`,

      off_desc:
        'Проверка геолокации Ваших гостей отключена. Включите проверку, чтобы избежать фальшивых заказов, которые могут быть сделаны вне зоны заведения.',
      about: `Для того, чтобы предотвратить фальшивые заказы, мы будем проверять местонаходжение в заведении каждого пользователя. Если Вы отключите эту функцию, то все риски и последствия фальшивых заказов Вы берете на себя.`,
      disable_check: `Отключить проверку геолокации`,
      check_disabled: `Вы отключили проверку геолокаци - создать заказ можно сразу после сканирования QR-кода.`,
      general_geo: `Включить обязательную проверку геолокации`,
      radius_ph: 'Радиус действия стикеров (в метрах)',
      optional_geo: 'Включить опциональную проверку геолокации',
      recommended_radius: 'Рекомендованный радиус: 50 метров',
      input_general: `Поставьте метку на карте, которая соответствует точному местонаходжению Вашего заведения и укажите радиус действия системы INSIDE.`,
    },
    halls: {
      title: `Залы и столы`,
      halln: `Зал`,
      hall_name: `Название зала`,
      tables: `Столы`,
      hall: `Добавить залы`,
    },
    stickers: {
      title: `Заказать стикеры можно здесь`,
      about: `Выберите дизайн наклеек, которые лучше всего подходят для Вашего заведения.`,
      you_deside: `Цифровая печать дешевле, но наклейки такого типа пригодны до 1 месяца.
            Наклейки широкоформатной печати качественные, устойчивые, ламинированные и пригодны год и даже больше.`,
      choose_format: `Выберите формат печати`,
      digital: `Цифровой`,
      wideformat: `Широкоформатный`,
      order: `Заказать`,
      again: `еще раз`,
      amount: `шт.`,
      order_created: `Заказ создан`,
      in_print: `Ваши стикеры печатаются`,
      is_sent: `Стикеры отправлены заказчику`,
      wait_wide: `Ваши стикеры будут изготовлены в течение 14 дней`,
      wait_digital: `Ваши стикеры будут изготовлены в течение 2 рабочих дней.`,
      to_pay: `К оплате`,
      terms_of_delivery: `Условия доставки`,
      nova_poshta: `QR-коды будут доставлены сервисом "Новая Почта".`,
      input_data: `Укажите необходимые данные, чтобы мы могли отправить Вам QR-коды.`,
      reciver_name: `ФИО получателя`,
      phone: `Номер телефона`,
      np_warehouse: `Отделение Новой Почты`,
      choose_warehouse: `Выберите отделение`,
      online_prepay: `Онлайн предоплата`,
      what_you_pay_for: `Вы оплачиваете услугу печати QR-кодов.`,
      pay_order: `Оплатить заказ`,
      return: `Вернуться к выбору шаблона`,
      is_protected: `Ваши банковские данные надежно защищены и не передаются третьим лицам.`,
      download_lite: 'Загрузить стикер для INSIDE lite',
      no_sections:
        'Вы не можете заказать стикеры, пока не укажите количество залов и столов в настройках заведения.',
      is_protected: `Ваши банковские данные надежно защищены и не передаются третьим лицам.`,

      contacts: 'Укажите Ваши контакты, чтобы мы могли отправить стикеры.',
      name_ph: 'ФИО получателя',
      phone_ph: 'Номер телефона',
      address_ph: 'Адрес получателя',
      comment_ph: 'Комментарий',

      delivery_way: 'Выберите способ доставки',
      by_novaposhta: 'Нова Пошта',
      by_courier: `Курьером`,

      price: 'Стоимость Ваших стикеров: ',
      order_button: 'Оплатить стикеры',

      order_accepted:
        'Ваш заказ от {date} на печать наклеек {template} был принят.',
      choose_language: 'Выберите язык стикеров:',
    },
    self_serve: {
      title: `Самообслуживание`,
      if_turned_on: `Вашим гостям будет приходить оповещение про готовность заказа, и что они могут его забрать.`,
      turn_on: `Режим "Самообслуживание"`,
    },
  },
  preorder: {
    min_order_time: {
      title: `Минимальное время на приготовление`,
      current:
        'Гость может получить заказ не раньше чем через {time} от момента его создания.',
      input: `Укажите минимальное время, за которое клиент может сделать предзаказ.`,
    },
    time_limit: {
      title: `График работы`,
      current: 'Последний заказ принимается за {time} до закрытия.',
      zero: 'Последний заказ принимается до закрытия заведения.',
      input: `Укажите за сколько минут до закрытия заведения принимать последний заказ.`,
    },
    packaging: {
      // title: `Вартість упаковки`,
      // free_packaging: `Безкоштовна упаковка`,
      // free_packaging_about: `Упаковка повністю безкоштовна і не додається клієнту в чек.`,
      // paid_packaging_fixed: `Платна упаковка (стала вартість)`,
      // paid_packaging_price: `Вартість упаковки:`,
      // no_mater: `Вказана сума завжди додається клієнту в чек, в незалежності від вибраних страв і їх кількості.`,
      // paid_packaging_percent: `Платна упаковка (змінна вартість)`,
      // paid_packaging_about: `Система автоматично обчислює загальну вартість упаковки, підбираючи розмір або об'єм упаковки під кожну страву.`,
      // volume: `Об'єм упаковки`,
      // g: `Грам`,
      // l: `Літр`,
      // price: `Вартість`,
      // price_placeholder: `30 грн`,
      // add_packaging: `Додати упаковку`,
      // ensure: `Переконайтесь, що для кожної страви знайдеться упаковка, що може її вмістити.`
      title: 'Стоимость упаковки',
      type_free: 'Бесплатная упаковка',
      type_non_free: 'Платная упаковка',
      type_constant: 'Фиксированная стоимость',
      type_weighted: 'Переменная стоимость',

      no_variants:
        'В этом блюде пустая первая группа вариантов. Добавьте хотя бы 1 вариант чтобы настроить упаковку или удалите группу вариантов чтобы настроить цену упаковку на целое блюдо.',

      dish_desc:
        'Укажите объем упаковки и ее стоимость. Если упаковка для этого блюда зависит от его веса, то укажите несколько упаковок, наш алгоритм автоматически подберет нужную.',

      constant_hint:
        'Указанная Вами сума будет автоматически добавлятся клиенту в чек.',

      unit_ph: 'Тип',
      unit_l: 'Напиток',
      unit_g: 'Блюдо',
      unit_cm: 'Пицца',

      weight_l: `Объем`,
      weight_g: 'Вес',
      weight_cm: 'Размер',
      weight_null: '-',

      price_ph: 'Стоимость',

      add_package: 'Добавить упаковку',
      type_hint: 'При добавлении упаковки укажите ее тип.',

      smart_comment:
        'Стоимость упаковки будет вычислена автоматически. Перейдите в меню, чтобы настроить упаковку для каждого блюда отдельно.',
      smart_btn: 'Перейти к настройкам меню',
    },
    payment: {
      title: `Оплата`,
      cash: `Наличными`,
      cash_courier: `Клиент будет рассчитываться наличными с курьером при получении заказа.`,
      cash_about: `Клиент будет рассчитываться наличными при получении заказа.`,
      card: `Терминалом`,
      card_about: `Оплата карточкой с помощью терминала.`,
      online: `Онлайн`,
      online_about: `Онлайн оплата заказа за Вашими реквизитами (предоплата)`,
      bonus: 'Бонусами',
    },
    allow_reservation: {
      title: 'Способ получения заказа',
      eat_in: 'В заведении (eat in)',
      takeaway: 'С собой (takeaway)',
      warning:
        'Система TAKEAWAY не будет работать пока Вы не выберите хотя бы 1 способ получения заказа',
      comment:
        'Вы можете настроить логику работы системы TAKEAWAY под свое заведение. Выберите возможные способы сделать заказ.',
    },
  },
  delivery: {
    min_check: {
      title: `Минимальная сумма чека`,
      off_desc: 'Вы можете указать минимальную сумму заказа.',
      on_desc:
        'Гости смогут сделать заказ только если его стоимость превысит минимальную.',
      min_about: `Укажите минимальную сумму заказа, которую клиент должен набрать, чтобы отправить заказ.`,
    },
    max_check: {
      title: 'Максимальный чек с платной доставкой',
      desc:
        'Доставка заказов на сумму не менее указанной суммы будет бесплатной для гостя',
    },
    price: {
      title: 'Стоимость доставки',

      type_free: 'Бесплатная',
      type_conditional: 'Переменная',
      type_constant: 'Платная',

      amount_ph: 'Введите сумму',

      free_after: 'Доставка бесплатная после указанной суммы',
      rules_before: 'Рассчет стоимости доставки до указанной суммы',

      fixed_price: 'Фиксированая стоимость',
      courier_price: `Тариф курьера`,
      courier_desc: `Если стоимость доставки считается по тарифу курьера, то клиент рассчитывается за доставку при получении.`,

      add_cost_to_check: 'Добавлять стоимость доставки в чек',
    },
    geo: {
      title: `Зоны доставки`,
      input_zones: `Укажите зоны (координаты и радиусы), в которых работает доставка из Вашего заведения.`,
      no_zones: `Зоны не указаны`,
      zones_hint: `Кликните в нужном месте на карте чтобы установить маркер для`,
      zone_t: `зоны`,
      zone: `Зона`,
      radius: `Радиус (км)`,
      add_zone: `Добавить зону`,
      explain:
        'QRWaiter автоматически проверяет адрес клиента, и дает возможность сделать заказ только если он входит в зону доставки.',

      click_to_add: `Нажмите на соответствующее место на карте, чтобы добавить зону доставки (центр зоны не объязательно должен совпадать с адресом заведения)`,
      desc:
        'Укажите зоны доставки на карте. Для более точной настройки, можно добавить несколько зон.',
    },
  },
  reserve: {
    price: {
      title: `Платное бронирование`,
      free: 'Бронирование бесплатное',
      setup:
        'Для включения этой функции необходимо выбрать счет для зачисления средств',
      input: `Вашим гостям необходимо оплатить депозит (онлайн) для того, чтобы забронировать стол.`,
    },
    max_days: {
      title: `Дата бронирования`,
      input: `Вы можете указать на сколько дней вперед можно сделать бронирование.`,
    },
    max_guests: {
      title: `Количество человек`,
      input: `Вы можете указать максимальное количество человек, на которое можно произвести бронирование.`,
    },
    payment: {
      title: `Оплата`,
      to_card: `Перевод на номер карты`,
      input_card: `Укажите номер карты, на которую будут поступать средства за заказ:`,
      to_bank_account: `Перевод на расчетный счет`,
      input_bank: `Укажите данные расчетного счета, на который будут поступать средства за заказ:`,
      account_number: `Номер счета (14 цифр)`,
      mfo: `МФО счета`,
      edrpou: `Код ЕДРПОУ`,
      company_name: `Название компании`,
      liqpay: `Оплата на аккаунт мерчанта Liqpay`,
      api_key: `Укажите ключи API от Вашего аккаунта Liqpay, чтобы  онлайн оплата осуществлялась напрямую на Ваш счет Liqpay.`,
      pubkey: `Публичный ключ API`,
      privkey: `Приватный ключ API`,
      no_liqpay: `Не имеете аккаунта Liqpay?`,
      liqpay_register: `Регистрация`,
      data_is_protected: `Ваши банковские данные надежно защищены и не передаются третьим лицам`,
    },
    allow_same_day: {
      title: 'Безопасное бронирование',
      comment:
        'Для того чтобы избежать переброни и недоразумений с гостями, мы разрешаем Вашим гостям сделать бронирование только на следующий день. Но Вы можете выключить это ограничение, сняв галочку.',
      toggle: 'Безопасное бронирование',
    },
  },
  busy_modal: {
    title: 'Подождите, обновляем информацию...',
  },
  menu_languages: {
    btn_add: 'Добавить перевод',

    settings_title: 'Переводы меню',
    main_language: 'Основной язык',
    alt_language: 'Альтернативный язык',
    preview_title: 'Предпросмотр оригинала',
    preview_desc:
      'Включите эту опцию чтобы подсветить непереведенные названия и видеть текст оригинала при вводе перевода',
    remove_language_confirm:
      'Вы уверены, что хотите удалить переводы для этого языка?',
  },
  updated_language_modal: {
    title: 'Добавление перевода',
    subtitle: 'Выберите язык, на который Вы хотите перевести это меню',
    subtitle_original: 'Пожалуйста, выберите основной язык для этого меню',
    search: 'Поиск',
    btn_add: 'Добавить язык',
    languages_plural: 'Язык не выбран | {n} язык вибран | {n} языка вибрано',
    set_original: 'Установить язык оригинала',
  },
  language_modal: {
    head: 'Добавление альтернативного языка',
    choose_lang: 'Выберите язык для меню',
    menu_lang_comment:
      'Переводы для альтернативных языков Вы можете прописать поверх оригинальных названий в редакторе категорий и настройках блюда. Непереведенные названия будут подсвечиватся красным цветом.',
    confirm_btn: 'Добавить язык',
    cancel_btn: 'Отмена',
  },
  integrations: {
    order_title: 'Заказать интеграцию',
    order_desc:
      'Если Вы не нашли Вашу POS-систему в списке интеграций, то Вы можете оставить заявку и мы настроим интеграцию с Вашей системой дополнительно.',
    order_button: 'Заказать интеграцию',
    order_ph: 'Название POS-системы',
    order_sent: 'Вашу заявку отправлено.',
    supported: {
      title: `Доступные интеграции`,
      you_can_connect: `Вы можете подключить стороннюю систему учета к системе QRWaiter.`,
      currently_supported: `Сейчас мы поддерживаем следующие интеграции (нажмите, чтобы подключить):`,
    },
    poster_settings: {
      title: `Заведение`,
      choose_poster_spot: `На Вашем аккаунте Poster есть несколько заведений. Укажите заведение в системе Poster, на терминалы которого будут приходить заказы из QRWaiter.`,
      choose_spot: `Выберите заведение`,
      term_no: `Терминал`,
      update_prices_request:
        'Поскольку Вы изменили заведение Poster, желаете ли Вы обновить цены в меню QRWaiter в соответствии с прейскурантом нового завдения Poster, которое Вы выбрали?',
    },
    poster_menu_input: {
      search_ph: 'Поиск товара или тех. карты в Poster...',
      modificator_input_none: '- без модификатора -',
      modificator_input_prefix: 'Модификатор',
    },
    pos_product_link: {
      title: 'Интеграция с POS',
      desc:
        'Вы можете привязать тех. карту (или ее модификацию) с POS системы к этому блюду',
      has_variants:
        'Интеграция с POS-системою настроена через группу модификаторов (варианты). К каждому модификатору подвязана отдельная тех. карта с POS системы.',
    },
    iiko_menu_input: {
      search_ph: 'Поиск тех. карты в iiko...',
    },
    poster_status: {
      title: 'Інтеграция с Poster',
      active: 'Активная',
      description:
        'Эта интеграция позволяет синхронизировать Ваш аккаунт QRWaiter с аккаунтом Poster. Автоматически будут импортированы меню, персонал и столы.',
      connect: 'Включить интеграцию',
      // active: 'Интеграция с Poster включена.',

      disable: 'Отключить интеграцию',
      disable_modal:
        'Для отключения интеграции перейдите в каталог Poster и нажмите "Отключить" на странице приложения QRWaiter.',
      account_id: 'Аккаунт Poster:',
      was_disconncted:
        'Интеграция с QRWaiter была отключена в админ панели Poster. Для корректной ее работы, необходимо подключить интеграцию снова.',
    },
    poster_health: {
      title: 'Обратите внимание!',
      not_healthy: 'Интеграция работает некорректно',
      waiters_title: 'Отсутствуют следующие сотрудники в системе QRWaiter:',
      waiters_desc:
        'Система QRWaiter не сможет корректно создать чек в Poster, если заказ на терминале приймет сотрудник, которого нет в QRWaiter.',

      halls_title: 'Отсутствуют следующие залы в системе QRWaiter:',
      halls_desc:
        'Система QRWaiter не сможет создать чек на столе, зал которого не импортирован в QRWaiter.',
    },
    poster_sync: {
      title: 'Синхронизация',
      description:
        'Выберите, какие параметры следует синхронизировать в автоматическом режиме с системой Poster',
      sync_menu: 'Меню',
      sync_tables: 'Синхронизировать залы и столы',
      sync_waiters: 'Сотрудники',
      sync_storage: 'Остатки на складах',
      sync_transactions: 'Чеки INSIDE',

      desc_storage:
        'Эта опция будет синхронизировать наличие блюд в меню QRWaiter в зависимости от остатков ингридентов и товаров на складе Poster.',
      desc_transactions:
        'Эта опция будет синхронизировать содержимое заказов системы INSIDE при изминении соответсвующего чека в Poster',
      desc_menu:
        'Эта опция постоянно будет синхронизировать цены и фотографии на блюда и модификаторы в меню',
      desc_waiters:
        'При создании сотрудника в Poster он будет также автоматически добавлятся в систему QRWaiter',
    },
    poster_instant_ui: {
      title: 'Интерфейс заказа',
      desc:
        'Включите эту опцию чтобы интерфейс приема заказов на терминале Poster показывался сразу после уведомления о новом заказе.',
    },
    poster_integration: {
      title: `Активная интеграция`,
      working: `Работает интеграция с системой Poster.`,
      connected: `Подключена`,
      user: `пользователем`,
      import_title: 'Импорт данных',
      import_hint: 'Выберите данные, которые желаете импортировать с Poster.',
      import_menu: `Импортировать меню`,
      import_workers: `Импортировать работников`,
      import_halls: `Импортировать залы и столы`,
      warning_workers: `При импорте работников с Poster, информация о работниках в системе QRWaiter будет перезаписана (утрачена). Вы уверены?`,
      warning_halls: `При импорте настроек залов и столов с Poster, информация о них в системе QRWaiter будет перезаписана (утрачена). Вы уверены?`,
      warning_menu:
        'При импорте будут созданы две полные копии меню с названиями "Кухня" и "Бар".',
    },
    poster_connect: {
      title: `Интеграция`,
      wait: `Подождите, идет настройка интеграции...`,
      success: `Интеграция настроена, теперь Вам доступны функции интеграции такие как импорт меню.`,
      return: `Вернуться к интеграциям`,
      failed: `Не удалось завершить процесс интеграции. Пожалуйста, повторите попытку позже или обратитесь в тех. поддержку.`,
    },
    iiko_connect: {
      title: 'Интеграция с iiko',
      connect_btn: 'Подключить интеграцию',
      active: 'Активная интеграция с ',
      disconnect: 'Отключить интеграцию',
      download: 'Скачать плагин',
      confirm_disconnect: 'Вы уверены, что хотите отключить интеграцию с iiko?',
    },
    iiko_connect_modal: {
      download: '1. Загрузите архив с нашим плагином интеграции для iikoFront:',
      extract:
        '2. Распакуйте скачаный архив в подпапку <span class="c-white">"Plugins/QRWaiterIikoPlugin"</span>, которую можно найти по пути где установлен iikoFront, по умолчанию это <span class="c-white">C:\\Program Files\\iiko\\iikoRMS\\Front.Net</span>). В результате файл QRWaiterIikoPlugin.dll должен быть размещен по пути <span class="c-white">C:\\Program Files\\iiko\\iikoRMS\\Front.Net\\Plugins \\QRWaiterIikoPlugin\\QRWaiterIikoPlugin.dll</span>',
      license:
        '3. Установите 1 слот лицензии apiPayment <span class="c-white">(ID 21016318)</span>, она необходима для работы плагина QRWaiter.',
      restart: '4. Перезапустите iikoFront.',
      connect:
        '5. С помощью дополнительных меню плагинов откройте меню QRWaiter и введите Ваш код подключения',
      autoclose: 'Это окно будет автоматически закрыто после ввода кода.',
    },
    iiko_disconnect: {
      title: 'Пожалуйста, подождите, идет отключение интеграции...',
      subtitle: 'Убедитесь, что iikoFront открыт.',
    },
    iiko_import: {
      menu_btn: 'Импортировать меню',
      workers_btn: 'Импортировать сотрудников',
      tables_btn: 'Импортировать залы и столы',

      menu_sent:
        'Запрос на импорт меню отправлен. Пожалуйста, убедитесь, что iikoFront открыт. Меню будет импортировано через несколько секунд.',

      workers_confirm:
        'Вы уверены, что хотите импортировать данные сотрудников из iiko? Текущие настройки будут перезаписаны.',
      tables_confirm:
        'Вы уверены, что хотите импортировать данные залов и столов из iiko? Текущие настройки будут перезаписаны',

      workers_sent:
        'Запрос на импорт сотрудников отправлен. Пожалуйста, убедитесь что интерфейс iikoFront открыт.',
      tables_sent:
        'Запрос на импорт залов и столов отправлен. Пожалуйста, убедитесь что интерфейс iikoFront открыт.',
    },
  },
  reviews: {
    averange: `Средняя оценка`,
    reviews: `Отзывы`,
    no_reviews: 'Здесь будут отображатся отзывы от Ваших гостей.',
    no_review_title: 'У вас пока нет отзывов.',
    anonymous: 'Аноним',
  },
  settings: {
    title: `Настройки`,
    mail: {
      title: `Изменение адреса электронной почты`,
      current: `Ваш текущий адрес`,
      new: `Введите новый адрес`,
      wait: `Подождите...`,
      confirm: `Для подтверждения введите пароль`,
      change: `Изменить адрес`,
      sent: `На указанный новый адрес было отправлено письмо для подтверждения.`,
      errorp: `Не удалось изменить адрес. Проверьте правильность пароля.`,
      errorl: `Не удалось изменить электронную почту. Проверьте правильность ссылки.`,
      changed: `Ваш адрес электронной почты успешно изменен. Переадресация...`,
    },
    delete: {
      title: `Удаление аккаунта`,
      pwd: `Пароль`,
      password: `Для удаления аккаунта введите пароль`,
      warn: `ВНИМАНИЕ!`,
      warnt: `Это действие является необратимым и удаляет всю информацию, связанную с Вашим аккаунтом QRWaiter: заведение, меню, заказ, настройка и др.`,
      unable: ` Не удалось удалить аккаунт. Пожалуйста, проверьте правильность пароля.`,
      about: `Вы можете удалить свой аккаунт QRWaiter, однако это действие является необратимой.`,
      delete: `Удалить аккаунт`,
      cancel: `Отмена`,
      deleted: `Аккаунт удален, переадресация...`,
    },
    language: {
      title: `Язык`,
      choose: `Выберите нужный язык для уведомлений:`,
    },
    password: {
      title: `Изменение пароля`,
      current: `Текущий пароль`,
      new: `Новый пароль`,
      repeat: `Повторите новый пароль`,
      change: `Изменить пароль`,
      success: `Пароль успешно изменен!`,
      errord: `Ваши новые пароли не совпадают.`,
      erroro: `Изменить пароль не удалось. Проверьте правильность текущего пароля.`,
    },
    two_factor: {
      title: 'Двухфакторная авторизация',
      change_phone: 'Изменить номер телефона',
      description:
        'Защитите свой аккаунт QRWaiter и включите двухфакторную авторизацию по СМС.',
      description_active:
        'На этот номер будет приходить подтверджение каждый раз, когда выполняется вход в Ваш аккаунт QRWaiter.',
      checkbox: 'Включить подтверджение по СМС',

      confirm_code_ph: 'Код подтверджения (6 цифр)',

      set_phone_desc: 'Укажите свой номер телефона',
      set_code_desc: 'Введите код из SMS',

      confirm_phone: 'Подтвердить номер телефона',

      is_active: 'Двухфакторная авторизация активирована.',

      send_sms: 'Отправить СМС',
    },
  },
  marketing: {
    title: 'Маркетинг',
    tab_campaigns: 'Рекламные кампании',
    tab_loyalty: 'Программа лояльности',
    tab_promocodes: 'Промокоды',
    tab_discounts: 'Промоакции',

    desc_campaigns:
      'Создавайте ссылки для рекламных кампаний и отслеивйте их эффективность',
    desc_loyalty: 'Предоставляйте своим гостям бонус от чека',
    desc_promocodes: 'Создавайте промокоды для проведения розыгршей или акций',
    desc_discounts: 'Указывайте промоакции на категории или блюда в меню',
  },
  campaign_card_old: {
    iqos_title: 'Ссылка для рекламы',
    title_ph: 'Название кампании',
    link: 'Ссылка:',
    period: 'Период действия:',
    total_visits: 'Количество просмотров меню:',
    unique_visits: 'Количество уникальных пользователей:',
    delete: 'Удалить кампанию',
    confirm_delete: 'Вы уверены, что хотите удалить эту кампанию?',
    add_campaign: '+ Создать ссылку для рекламной кампании',
    new_campaign_ph: 'Название новой кампании',
    iqos_desc:
      'Используйте эту ссылку для рекламы то отслеживайте ее эффективность.',
    force_mode_none: '- не пропускать вибор системы -',
  },
  address_details: {
    types: {
      entrance: `Подъезд`,
      floor: 'Этаж',
      flat: 'Квартира',
    },
    title: 'Доставка к двери',
    description_old:
      'Укажите дополнительные детали адреса, которые клиент должен указать чтобы сделать заказ на доставку.',
    description: `Если у Вас есть курьеры которые доставляют "к двери", то Вы можете запрашивать у гостей дополнительные детали адреса. Эти детали необязательные.`,
    required:
      'По умолчанию QRWaiter требует указать только адрес и номер дома.',
  },
  update_bar: {
    text:
      'Доступно обновление панели администратора. Страница перезагрузиться автоматически через 30 сек.',
    button: 'Перезагрузить сейчас',
    description:
      'Укажите дополнительные детали адреса, которые клиент может указать для заказа на доставку (эти поля будут необъязательными).',
  },
  tables: {
    orders_history: 'История заказов',
    payments_history: 'История платежей',
    search: 'Поиск...',
    export: 'Экспорт',
  },
  halls_tables: {
    reserve_title: 'Столы для бронирования',
    title: 'Залы и столы',
    hall_ph: 'Название зала',
    no_halls:
      'Залы и столы не настроены. Нажмите на кнопку редактирования, чтобы добавить их.',
    add_hall: 'Добавить зал',
    places_count: 'Места',
    places_count_plural: 'место | мест',
    not_filled: 'Не указано',
    remove_hall: 'Удалить зал',
    confirm_remove_hall:
      'Вы уверены, что хотите удалить этот зал? Стикеры, напечатанные на столы этого зала, перестанут работать.',
    reserve_missing: 'Стол для бронирований не выбран',
    room: 'Номер',
    table: 'Стол',
    reserve_red_desc:
      'Столы, что выделены красным цветом, не имеют настроенного количества мест. Для системы RESERVE можно выбрать только столы, которые имеют указанное количество мест',
    name_ph: 'Название стола',
    places_ph: 'Количество мест',
    delete_btn: 'Удалить',
    add_btn: 'Добавить стол',
    description:
      'Укажите залы, количество столов в них и количество свободных мест за каждым столом. Это необходимо для правильного рассчета стикеров для системы INSIDE и безопасной брони в RESERVE.',
    reserve_description:
      'Чтобы Ваши гости могли сделать бронь стола через QRWaiter, Вам необходимо выделить как минимум 1 стол, который гарантировано будет свободен в случае брони через систему RESERVE.',
    reserve_description2:
      'Допустимое количество мест подсчитывается автоматически. Чтобы изменить залы или количество столов, перейдите в общие настройки заведения.',
    pos_sync: 'Синхронизировать с POS системой',
  },
  changelog: {
    title: 'Уведомления от QRWaiter',
  },
  reserve_policy: {
    title: 'Политика RESERVE',
    text:
      'Чтобы система RESERVE была доступна в марктеплейсе QRWaiter, Вам нужно прочитать и принять условиями политики RESERVE.',
    checkbox: 'Я прочитал и согласен с условиями политики QRWaiter | RESERVE',
  },
  corporate_employees: {
    all_permissions: {
      general: 'Настройки заведения',
      stats: 'Статистика',
      marketing: 'Маркетинг',
      systems: 'Настройка систем',
      menu: 'Редактор меню',
      integrations: 'Интеграции',
      payment: 'Онлайн-оплата',
      '*': 'Полный доступ',
    },
  },
  auditlog: {
    title: 'История изменений',
    columns: {
      user: 'Пользователь',
      date: 'Дата',
      time: 'Время',
      action: 'Действие',
    },
    select_cafe: 'Выберите заведение',
    types: {
      cafe_settings:
        'Изменил общие настройки заведения ({name}, {description}, {address})',
      clients_export: 'Экспортировал клиентскую базу',
      pay_methods: 'Изменил методы оплаты ({mode})',
      marketing_new_campaign: 'Создал новую ссылку для рекламы ({title})',
      marketing_remove_campaign: 'Удалил ссылку для рекламы ({title})',
      loyalty_change: 'Изменил процент программы лояльности ({percent}%)',
      cafe_schedule: 'Изменил график работы заведения',
      online_menu_link: 'Изменил ссылку на онлайн меню ({link})',
      social_links: 'Изменил соц. сети заведения',
      waiters: 'Изменил настройки официантов',
      poster_import_menu: 'Импортировал меню с Poster',
      poster_import_tables: 'Импортировал залы и столы с Poster',
      poster_import_workers: 'Импортировал работников с Poster',
      mode_disable: 'Отключил систему ({mode})',
      mode_enable: 'Подключил систему ({mode})',
      inside_services: 'Изменил услуги в INSIDE',
      inside_geolocation: 'Изменил настройки геолокации в INSIDE',
      packaging: 'Изменил настройки упаковки ({mode})',
      delivery_price: 'Изменил настройки цены доставки',
      reserve_allow_today: 'Изменил настройку безопасного бронирования',
      menu_create: 'Создал меню "{title}"',
      menu_tag: 'Изменил тег меню "{tag}"',
      menu_delete: 'Удалил меню "{title}"',
      menu_duplicate: 'Сделал копию меню "{title}"',
      menu_toggle: 'Переключил режим "{mode}" для меню {title} ({value})',
      create_cafe: 'Создал новое заведение ({name}, {address})',
      regional_settings: 'Обновил региональные настройки',
      add_employee: 'Создал нового сотрудника {name}, {email}',
      remove_employee: 'Удалил сотрдуника {name}, {email}',
      update_employee: 'Изменил настройки сотрудника {email}',
      remove_menu_product:
        'Удалил блюдо {name} из категории {category} ({menu_title})',
      remove_menu_category:
        'Удалил категорию {category_name} из меню {menu_title}',
      add_online_merchant: 'Создал онлайн мерчанта ({gateway})',
      update_online_merchant: 'Изменил настройки онлайн мерчанта',
      change_client_discounts:
        'Изменил настройки бонусов и скидок для клиента ({client_name})',
      create_promocode: 'Создал промокод',
      delete_promocode: 'Удалил промокод ({count} шт.)',
      create_discount: 'Создал скидку',
      delete_discount: 'Удалил скидку ({size}%)',
      change_menu_pay_receiver:
        'Изменил счет для онлайн оплаты для меню {menu_title}',
      change_menu_product_price: 'Изменил цену на блюдо {dish_name} ({price})',
      change_menu_product_photo: 'Изменил фотографию блюда {dish_name}',
      create_menu_product_modificators:
        'Создал группу модификаторов в блюде {dish_name}',
      delete_menu_product_modificators:
        'Удалил группу модификаторов {name} в блюде {dish_name}',
      cancel_subscription: 'Отменил подписку на систему ({mode})',
      change_mode_motd: 'Изменил текст окна приветствия ({mode})',
      change_reserve_price: 'Изменил цену на RESERVE ({price})',
      change_poster_sync: 'Изменил настройки сихнронизации с Poster',
      change_tables: 'Изменил настройки залов и столов ({halls_count} залов)',
      change_food_flavors: 'Изменил категории заведения в маркетплейсе',
      change_menu_product_integration:
        'Изменил настройки интеграции блюда {dish_name} ({platform})',
      transfer_menu_product: 'Переместил блюдо {dish_name}',
      delete_menu_product_modificator:
        'Удалил модификатор {modificator_name} из блюда {dish_name}',
      change_menu_product_name: 'Изменил название блюда {dish_name}',
    },
  },
  add_corporate_cafe: {
    modal_title: 'Добавление нового заведения',
    button: 'Добавить',

    tab_new: 'Новое',
    tab_duplicate: 'Дубликат',

    add_chain: 'Создать сеть',
    chain_ph: 'Название сети',

    tab_cafe: 'Заведение',
    tab_chain: 'Сеть',

    new_desc:
      'Укажите данные для заведения, которые Вы хотите зарегистрировать.',
    duplicate_desc:
      'Выберите заведение, с которого Вы хотите продублировать меню, системы и их настройки.',

    name_ph: 'Название заведения',
    address_ph: 'Адрес',

    select_cafe: '- Выберите заведение -',

    cancel: 'Отмена',
    register: 'Создать',

    no_chain: '- Заклад не в мережі -',
  },
  corporate_users: {
    desc:
      'Вы можете предоставить доступ к Вашему аккаунту с разными уровнями доступа.',
    add_user: '+ Добавить аккаунт',
  },
  add_employee: {
    add_user: 'Добавить пользователя',
    title: 'Добавление аккаунта',
    comment:
      'Вы можете предоставить доступ к Админ панели заведения своим сотрудникам, настроив нужный уровень доступа.',
    name_ph: `Укажите имя пользователя`,
    role_ph: 'Укажите должность пользователя',
    email_ph: 'Электронная почта пользователя',
    phone_ph: 'Укажите номер телефона',
    choose_permissions:
      'Выберите, к каким функциям будет иметь доступ новый пользователь',
    choose_cafe: 'Выберите заведение',
    cancel: 'Отменить',
    confirm: 'Отправить приглашение',
  },
  employee_card: {
    user_num: 'Пользователь',
    not_activated: 'Приглашение отправлено',
    cancel_invite: 'Отменить приглашение',
    activated: 'Аккаунт активирован',
    delete_warning:
      'Если Вы удалите пользователя, то его доступ к аккаунту будет потерян.',
    delete_button: 'Удалить',

    not_activated_desc:
      'Приглашение было отправлено на электронную почту пользователя. Доступ будет предоставлен, как только он подтвердит регистрацию.',
    activated_desc:
      'Аккаунт пользователя активирован, он имеет доступ ко всем перечисленным функциям.',
  },
  moeco_partner: {
    title: 'Экологическая доставка',
    connect_desc:
      'Вы можете подключить интеграцию по доставке з партнером "moeco". Водители будут заранее оповщены о заказе и Вам останеться только вовремя его приготовить.',
    connect_btn: 'Подключить "Эко" доставку',
    pending_desc: `Вашу заявка принята, партнер по доставке свяжеться с Вами в ближайшее время.`,
    active: 'Активная эко-доставка по следующему тарифу:',
    cost: 'Стоимость доставки:',
    refuse_cost: 'Стоимость отмены доставки:',
    payer_client: 'За доставку платит клиент',
    payer_cafe: 'За доставку платит заведение',
    payer_conditional: 'Оплата доставки зависит от суммы чека',
    conditional_desc:
      'Стоимость доставки чека, сумма которого большая за указанную, будет оплачивать заведение.',
    conditional_example:
      'Например, если указать два условия (500 руб сумма чека, 100 руб доставка) и (1000 руб сумма чека, 70 руб доставка), то для заказов до 500 руб доставка будет стоить 100 руб, для заказов на сумму от 500 до 1000 руб - 70 руб, а для заказов на 1000 руб и больше - доставка будет бесплатной.',

    smart_option: 'Автоматический заказ машины',
    manual_option: 'Ручной заказ машины',
    smart_desc:
      'Система QRWaiter автоматически будет заказывать машину на нужное время, официанту нужно будет только принять заказ.',
    manual_desc:
      'Машину нужно будет заказывать вручную официанту, указывая время ее подачи.',
  },
  moeco_block: {
    title: 'Эко доставка от "Мое Такси"',
    comment:
      'Вы можете подключить интеграцию с нашим партнером по доставке "Мое Такси". Водители будут автоматически заранее оповещены про новые заказы на доставку. Вам останется только вовремя их приготовить.',
    comment_2: 'Больше никаких ожиданий на линии диспетчера 😉',

    connect_btn: 'Подключить интеграцию с "Мое Такси" 🚀',

    request_sent:
      'Ваша заявка отправлена. Как только "Мое Такси" подтвердит ее - Вы получите уведомление.',

    planned_count:
      'Плановое количество заказов, которые Вы должны сделать через интеграцию:',

    ready_title: 'Выберите режим заказа машины для доставки',
    smart_option: 'Автоматический',
    manual_option: 'Ручной',

    smart_desc:
      'Система QRWaiter автоматически будет заказывать машину на нужное время, официанту нужно будет только принять заказ.',
    manual_desc:
      'Для вызова машины нужно будет нажать кнопку "Заказать машину" в приложении для персонала. Кнопка вызова появляется под каждым принятым заказом.',
    price: 'Ваш тариф:',
    disconnect: 'Отключить интеграцию с "Мое Такси" 😕',
  },
  client_base: {
    title: 'Клиентская база',
    total_orders: 'Всего заказов',
    total_visits: 'Визитов',
  },
  serving_fee: {
    title: 'Комиссия за обслуживание',
    enable: 'Включить коммисию за обслуживание',
    mode_enable: 'Включить списание комиссии за обслуживание для этой системы',
    percent_ph: 'Размер комиссии (%)',
    comment: 'Этот процент будет добавлятся автоматически к каждому чеку.',
  },
  taxes_fee: {
    title: 'Налог',
    enable: 'Включать налог в чек заказа',
    percent_ph: 'Размер налога (%)',
    comment: 'Этот процент будет добавлятся автоматически к каждому чеку.',
  },
  taxi_price_panel: {
    limit_ph: 'Сумма чека',
    price_ph: 'Стоимость доставки',
    add_button: '+ Добавить условие',
  },
  delivery_shipping_time: {
    title: 'Время доставки',
    comment: 'Укажите сколько в среднем нужно времени чтобы доставить заказ.',
  },
  guests_count_flag: {
    title: 'Количество приборов',
    ask_count: 'Спрашивать количество приборов',
    paid_title: 'Платные приборы',
    paid_comment:
      'Вы можете указать стоимость каждого набора приборов. Общая стоимость будет добавлена в чек гостю автоматически',
    paid_ph: 'Цена 1 набора приборов',
    checkbox:
      'Система QRWaiter может запршивать у Ваших гостей количество приборов при создании заказа',
  },
  pay_methods: {
    cash: 'Наличные',
    card: 'Карта',
    online: 'Онлайн',
  },
  client_card: {
    phone: 'Телефон:',
    address: 'Адрес:',
    bonus_balance: 'Бонусный баланс:',
    average_check: 'Средний чек:',
    total_orders: 'Всего заказов:',

    option_bonuses: 'Накопление бонусов',
    option_discount: 'Установить постоянную скидку',

    table_date: 'Дата',
    table_time: 'Время',
    table_discount: 'Скидка',
    table_price: 'Сумма',
    table_bonuses: 'Бонусы',
  },
  workers_table: {
    add_button: 'Добавить',
    col_no: '№',
    col_name: `Имя`,
    col_pin: `PIN-код`,

    bot_connected: 'Подключен',
    bot_not_connected: 'Не подключен',

    confirm_delete:
      'Вы уверены что хотите удалить этого сотрудника? Это действие нельзя отменить.',
  },
  worker_profile: {
    new_ph: 'Новый сотрудник',
    orders_history: 'История заказов',
    tips_history: 'История чаевых',
    tips_cafe_balance: 'На счету заведения',

    phone_ph: 'Номер телефона',
    profile_title: 'Персональная информация',

    bot_panel_comment:
      'Отсканируйте этот QR-код с телефона офицанта, чтобы подключить уведомления',
    bot_panel_title: 'Уведомления для официантов',
    bot_offline: 'Официант отключил уведомления',

    tips_title: 'Баланс чаевых',
    tips_comment:
      'Тут отображаються чаевые официанта, которые гости оплатили онлайн.',
    tips_payout: 'Сделать выплату',
    tips_card_desc:
      'Ваши гости могут оставлять чаевые онлайн. Средства будут переведены напрямую на счет сотрудника. Оплата происходит с помощью P2P перевода.',
    tips_card_input:
      'Укажите реквизиты сотрудника, на которые он будет получать онлайн чаевые.',

    tips_card_title: 'Онлайн чайові',
    tips_technology: `Вы можете указать номер личного счета официанта, чтобы он мог напрямую получить чаевые. Платеж будет совершен по технологии P2P, как перевод между двумя физ. лицами`,

    attach_tables_title: 'Привязка столов',
    attach_all: 'Официанту приходять уведомления со всех столов.',
    attach_none: 'Официанту не приходять уведомления.',
    attach_certain:
      'Официанту приходять уведомления только с выбранных столов.',

    attach_tables_title_hotel: 'Привязка номеров',
    attach_all_hotel: 'Официанту приходять уведомления со всех номеров.',
    attach_none_hotel: 'Официанту не приходять уведомления.',
    attach_certain_hotel:
      'Официанту приходять уведомления только с выбранных номеров.',

    attach_no_tables: 'У Вас еще не настроены залы и столы',
    attach_setup_tables: 'Настроить залы и столы',

    modes_title: 'Уведомления систем',
    modes_comment:
      'Выберите системы из которых сотрудник будет получать уведомления',

    tipping_title: 'Чаевые',
    tipping_cash: 'Наличными',
    tipping_online: 'Онлайн',
    tipping_comment: `Ваши гости могут оставить чаевые. Соответствующая функция появиться в системе INSIDE после оплаты заказа.`,
    tipping_merchant:
      'Укажите мерчанта, через который будут проводится транзакции по оплате чаевых',
  },
  worker_tips_history: {
    col_date: 'Дата',
    col_time: 'Время',
    col_check: 'Чек',
    col_pay: 'Метод оплаты',
    col_total: 'Сумма',
    col_tip: 'Чаевые',
    col_balance: 'Баланс',
    col_discount: 'Скидка',
  },
  online_payment: {
    gateways: {
      comission: 'Комиссия',
      pb_target: 'Только для клиентов Приватбанка',
      any_target: 'Для клиентов любого банка',
      payu_target: 'Для клиентов банков стран, в которых работает система Payu',
      yookassa_target:
        'Для клиентов банков стран, в которых работает система ЮКасса',
      stripe_target:
        'Для клиентов банков стран, в которых работает система Stripe',
    },
    start: {
      desc:
        'Вы можете создать интеграцию с этой платежной системой, чтобы принимать онлайн платежи.',
      action: 'Создать интеграцию',
    },
    guide: {
      title: 'Инструкция по подключению',
      part1:
        'Для того чтобы подключить онлайн оплату, Вам нужно создать аккаунт в платежной системе.',
      part2:
        'Потом нужно будет скопировть "Публичный API ключ" и "Приватный API ключ", чтобы интеграция настроилась автоматически.',
      part3:
        'Также, для сбыта товаров онлайн, нужно иметь договор публичной оферты. QRWaiter генерирует этот договор автоматически. Для этого оставьте свои реквизиты.',
      part4:
        'Если у Вас нет аккаунта в этой платежной системе, Вы можете его зарегистрировать.',
      register_btn: 'Зарегистрировать мерчанта',
      add_btn: 'Добавить мерчанта',
      add_btn_hint:
        'Вы можете добавить еще один аккаунт этой платежной системы. Если Вам нужно чтобы средства за некоторые товары засчитывались на другой счет.',
    },
    help: {
      title: 'Посмотреть инструкцию с подключения',
      liqpay: {
        '0': 'Начните регистрацию мерчанта, указав свой номер телефона',
        '1':
          'Укажите данные Вашей компании. В поле "Веб-адрес" укажите ссылку на Ваше онлайн меню: <br><a href="#" class="c-orange">{menuLink}</a>',
        '2':
          'Активируйте компанию, указав счет, на который будут начислятся средства',
        '3': 'Скопируйте ключи API в соответствующие поля в QRWaiter',
        '4':
          'Активируйте оплату по Apple Pay, добавив домен app.qrwaiter.com.ua',
      },
      wayforpay: {
        '0': 'Нажмите "Подключить" та введите свой номер телефона.',
        '1': 'Создайте новый магазин и выберите опцию "Я владелец сайта"',
        '2': 'Укажите реквизиты Вашей компании',
        '3':
          'Заполните необходимую информацию про компанию и подпишите документы.',
        '4':
          'Скопируйте реквизиты мерчанта (ключи API) в соответсвтующие поля в QRWaiter.',
      },
      yookassa: {
        '0': 'Перейдите на форму регистрации',
        '1': 'Введите свой номер телефона и введите информацию о компании',
        '2':
          'Создайте тестовый и реальный магазин и скопируйте ключи API (публичным ключем является shopId).',
        '3':
          'Включите HTTP-уведомления в настройках интеграции и укажите URL системы QRWaiter:<br><b>https://qrwaiter.com.ua/api/yookassa/webhook</b>',
        '4':
          'Начните заполнение и подписание документов. В качестве ссылки на сайт укажите ссылку на Ваше онлайн меню. Более детальная информация по документам доступна в <a target="_blank" class="c-green" href="https://yookassa.ru/docs/support/merchant/payments/implement/docs">документации ЮКассы.</a>',
      },
      stripe: {
        '0': 'Перейдите на страницу регистрации',
        '1': 'Введите свои контактные данные и создайте аккаунт',
        '2': 'Перейдите к активации аккаунта через меню',
        '3': 'Заполните необходимые формы и документы',
        '4':
          'Скопируйте API ключи в QRWaiter. До актиации аккаунта Вы можете использовать тестовые ключи для проверки оплаты.',
        '5':
          'Нажмите "Подключить Stripe Webhook" чтобы создать вебхук для оплаты и завершить интеграцию.',
      },
    },
    delete_merchant: 'Удалить мерчанта',
    api_keys: {
      title: 'Ключи API',
      public_ph: 'Публичный API ключ',
      private_ph: 'Приватный API ключ',
      invalid_title: 'Введенные ключи неверны',
      invalid_desc:
        'Мы не смогли подключиться к платежной системе с этими ключами. Пожалуйста, проверьте правильность введенных данных или свяжитесь с тех. поддержкой.',
      test_title: 'Вы указали тестовые ключи API',
      test_desc:
        'Вы можете использовать эти ключи для проверки работы онлайн оплаты либо для прохождения процедуры активации мерчанта. Средства при этом сразу будут возвращатся плательщику. Для проведения реальных платежей Вам нужно указать "боевые" ключи API.',
    },
    company_details: {
      title: 'Реквизиты компании',
      type_ph: 'Тип компании',
      type_physical: 'ИП',
      type_llc: 'ООО',
      name_ph: 'Название компании',
      code_ph: 'ОКПО',
      address_ph: 'Юридический адрес компании',
      account_ph: 'Рассчетный счет',
      phone_ph: 'Контактный телефон',
      tax_ph: 'ИНН',
      email_ph: 'Электронная почта',
    },
    add_other_desc:
      'Вы можете добавить еще один аккаунт этой платежной системы, чтобы оплата за некоторые товары провдилась на другой счет.',
    add_other_btn: '+ Добавить еще одного мерчанта',
    add_other_title: 'Дополнительный аккаунт',
    menu_panel: {
      title: 'Меню мерчанта',
      comment:
        'Средства за оплату блюд из выбранных меню будут приходить на реквизиты этого мерчанта',
    },
  },
  regional_panel: {
    title: 'Региональные настройки',
    currency: 'Валюта заведения',
    timezone: 'Часовой пояс',
    language: 'Язык уведомлений',
    round_menu_prices: 'Округлять цены в меню',
  },
  system_motd: {
    title: 'Настройка интерфейса для гостя',
    motd_title: 'Текст в окне приветствия',
    btn_title: 'Название кнопки на странице выбора системы',
    popup_title: 'Название системы на окне приветствия',
    ph: 'Напишите сюда Ваш текст',
    desc_1:
      'Когда Ваши гости открывают систему {mode}, по умолчанию они увидят текст с описанием системы, тарифами по доставке и условиями использования',
    desc_2:
      'Вы также можете добавить на эту страницу специалные предложения, тарифы и обьяснения.',
  },
  chain_general: {
    title: 'Общая информация',
    name_ph: 'Название сети',
    desc_ph: 'Описание',
  },
  chain_settings: {
    title: 'Центральные настройки',
    option_menu: 'Меню',
    option_pos: 'POS-интегрции',
    option_payment: 'Платежные системы',
    option_integrations: 'Интеграции',

    cafe_modal_title:
      'Выбирите заведение, меню которого нужно скопировать и сделать основным меню сети.',
    cafe_modal_cancel: 'Отмена',
    cafe_modal_confirm: 'Включить общее меню',

    comment_1:
      'Вы можете центрально настраивать эти параметры. Тогда они будут применены ко всем заведениям сети.',
    comment_2:
      'Функции, в которых выключена центральная настройка, настраиваются отдельно в админ панели каждого заведения.',
  },
  timing_settings: {
    title: 'Настройки времени',
    last_order: 'Последний заказ',
    last_order_comment:
      'Укажите, за сколько времени до закрытия заведения принимать последний заказ.',

    cook_time: 'Ближайшее время для заказа',
    cook_time_desc:
      'Укажите минимальный промежуток времени, необходимый для приготовления одного заказа.',

    cook_time_warning:
      'QRWaiter будет отображать время для заказа с учетом этих параметров. Однако гость все равно получит точное время выполнение заказа после того как заказ будет принят заведением.',

    delivery_time: 'Время на доставку',
    delivery_time_comment:
      'Укажите время, необходимое в среднем для доставки одного заказа.',
    delivery_time_comment2:
      'Это значение будет учитыватся при отображении времени выполнения заказа.',

    time_ph: '0 мин',

    gap_warning:
      'При выбранных настройках гость не сможет выбрать время для заказа.',
  },
  user_contacts: {
    title: 'Мои контакты',
    name_ph: `Имя`,
    phone_ph: 'Номер телефона',
  },
  stickers_static: {
    title: 'Стикеры',
    subtitle_none: 'Для начала работы системы нужно заказать стикеры.',
    subtitle_ready: 'Стикеры активированы и готовы к работе ✅',

    comment_none:
      'Для работы системы {mode} нужны специальные стикеры. На каждый стол генерируется стикер с уникальным QR-кодом, чтобы система распознавала столы.',
    comment_none2:
      'Вы можете заказать стикеры в QRWaiter либо ж напечатать их самостоятельно.',

    button: 'Заказать дизайнерские стикеры',
    download: 'Загрузить QR-коды',
  },
  system_progress_bar: {
    not_active: 'Готовность системы',
    suspended: 'Система не оплачена',
    active: 'Система настроена и готова к работе',
    needed: 'Для старта работы системы, необходимо:',
    hint: 'Вы можете нажать на нужный блок для быстрого перехода к настройкам.',
  },
  store_card: {
    inside: [
      'Онлайн оплата',
      'Онлайн чаевые',
      'Заказ блюд и услуг',
      'Автоматический перевод',
      'QRWaiter AI ®',
      'Проверка геолокации',
      'Автоматическое распознавание столов',
      'Интеграция с POS-системами',
      'Формировние клиентской базы',
    ],
    delivery: [
      'Онлайн оплата',
      'Заказ блюд',
      'Автоматический перевод',
      'QRWaiter AI ®',
      'Интеграция с POS-системами',
      'Интеграция с службами доставки',
      'Настройка зон доставки',
      'Гибкие настройки условий и тарифов',
      'Формирование клиентской базы',
    ],
    preorder: [
      'Онлайн оплата',
      'Заказ блюд',
      'Автоматический перевод',
      'QRWaiter AI ®',
      'Интеграция с POS-системами',
      'Формировние клиентской базы',
    ],
    reserve: [
      'Онлайн оплата',
      'Депозит',
      'Система безопасных бронирований',
      'Календарь бронирований',
      'Интеграция с POS-системами',
      'Формировние клиентской базы',
    ],
    hotels: [
      'Проверка геолокации',
      'Автоматическое распознавание номеров',
      'Заказ страв и услуг',
      'QRWaiter AI ®',
      'Интеграция с POS-системами',
      'Формировние клиентской базы',
    ],

    pro_title: 'Все возможности QRWaiter в одной подписке',
    pro_long: 'Все возможности QRWaiter в одной подписке',

    stickers_required: '* Для подключения нужно заказать QR-стикеры',

    inside_long:
      'Цифровое меню внутри заведения, которое работает с помощью QR-кодов с привязкой к столам. Гости сканируют QR-код, получают доступ к меню и делают заказ. Заказ также приходит на POS-терминал, а официант получает соотвествующее уведомление. Также гостям доступны услуги и онлайн оплата заказа.',
    delivery_long: 'Система для організації власної доставки',
    reserve_long: 'Система для приема бронирований.',
    preorder_long:
      'Система для заказов наперед в режиме "с собой" или с бронированием столика',
    hotels_long:
      'Система для отелей, которая поможет оцифровать заказ еды, напитков и даже услуг рум-сервиса.',

    system_status: 'Статус системы',
    connected: 'Подключена',

    subscription_status: 'Статус подписки',
    trial_until: 'Пробный период до',
    paid_until: 'Оплачена до',
    recurring_payment: 'включено автоматическое списание',
    ended_at: 'Закончилась',

    disconnect: 'Отключить систему',
    subscribe: 'Оформить подписку',

    cancel: 'Отменить подписку',
    change_card: 'Изменить карту для оплаты',

    trial_bonus:
      'При оплате подписки в день подключения системы, Вы получите неделю подписки в качестве бонуса.',

    details: 'Подробнее',
    connect: 'Подключить',
    month: 'месяц',
  },
  new_store_card: {
    subscription_status: 'Статус подписки',
    system_status: 'Статус системы',

    status_active: 'Активная',
    status_inactive: 'Неактивная',
    status_subscribed: 'Оформлена',
    status_not_subscribed: 'Не оформлена',
    status_pending_approval: 'Ожидает подтверждения от банка',

    next_payment: 'Дата следующей оплаты',

    reconfirm_cancel:
      'Вы отключили систему {mode}, но подписка еще активная. Вы желаете отменить подписку?',
    reconfirm_btn_confirm: 'Да, отменить подписку',
    reconfirm_btn_cancel: 'Нет',

    ended_at: 'Закончилась',

    free: 'БЕСПЛАТНО',
    freemium_note:
      'По окончании пробного периода нужно будет оформить подписку для системы {mode}',
    trial_period: 'Бесплатный период',
    freemium_count: 'Бесплатные заказы',
    freemium_limit:
      'Для продолжения работы системы {mode} нужно оформить подписку',

    subscribe_btn: 'ОФОРМИТЬ ПОДПИСКУ',
    cancel_btn: 'ОТМЕНИТЬ ПОДПИСКУ',
    change_card_btn: 'СМЕНИТЬ КАРТУ ДЛЯ ОПЛАТЫ',
    update_payment: 'ОБновить платежную информацию',

    paid_till: 'Оплачено до',
    connected_card: 'Подключенная карта',

    paid_text:
      'Ваша подписка была отменена, но Вы можете использовать систему {mode} до окончания оплаченного периода.',

    recurring_enabled: 'Платеж будет проведен автоматически.',
    recurring_failed:
      'Оплата не удалась. Пожалуйста, обновите платежные данные. Система будет отключена через {days} дн.',
  },
  new_systems_features: {
    custom_page: ['🚀 Личная страница заведения', 'Web Mobile | Web Desktop'],
    menu_translation: ['🌍 Автоматический перевод меню'],
    pos_integration: [
      '🔗 Синхронизация с POS-системой',
      `• Импорт меню, залов и столов, персонала <br> • Синхронизация заказов в режиме онлайн <br> • Синхронизация меню - фото, цены, технические карты, остатки,`,
    ],
    orders_panel: [
      '📱 Панель заказов',
      'Приложение для персонала | iOS / Android',
    ],
    inside_orders: [
      '🚀 Заказы внутри заведения',
      'Система работает через QR-коды и автоматически распознает столы',
    ],
    online_payment: [
      '💳 Интеграция с платежными системами',
      'Для оплаты заказов онлайн | Apple Pay / Google Pay',
    ],
    online_tips: ['💸 Онлайн чаевые для персонала'],
    ai: ['🤖 QRWaiter AI', 'Рекомендации блюд на основе машинного обучения'],
    crm: ['👥 CRM', 'Формирование собственной клиентской базы'],
    delivery_orders: [
      '🛵 Заказы с доставкой',
      'Настройка всего процесса заказа',
    ],
    takeaway_orders: ['🌯 Заказы с собой', 'Настройка всего процесса заказа'],
    sms_verification: ['🔒 Верификация клиентов по СМС'],
    push_notifications: ['🔔 Push-уведомления при изменении статуса заказа'],
    reserve_orders: [
      '🛎 Бронирование столов</b><br>Настройка всего процесса заказа',
    ],
    reserve_deposit: ['💰 Депозит для бронирования</b>'],
    reserve_calendar: ['🗓 Календарь бронирований</b>'],

    pro_inside_orders: '<b>🚀 Заказы внутри заведения</b><br>Система INSIDE',
    pro_delivery_orders: '<b>🛵 Заказы с доставкой</b><br>Система DELIVERY',
    pro_takeaway_orders: '<b>🌯 Заказы с собой</b><br>Система TAKEAWAY',
    pro_reserve_orders: '<b>🛎 Бронь столов</b><br>Система RESERVE',
  },
  stickers_card: {
    custom_comment:
      'Вы можете загрузить шаблон на основе которого можна создать собственный уникальный дизайн. Также Вы можете заказать у нас разработку уникального дизайна для Вашего заведения',
    download: 'Шаблон',
    format_svg: 'Формат файла должен быть .svg',
    choose_system_ph: 'Выберите систему',
    choose_system: 'Выберите систему, для которой желаете заказать стикеры',
    different_halls: 'Вы можете заказать разные стикеры для разных залов',
    add_btn: 'Добавить в корзину',
    choose_file: 'Выберите файл...',
    upload_custom: 'Загрузить собственный дизайн',
    uploaded: 'Загружено',
    direct_sticker: 'Обычные',
    inside_sticker: 'Для столов',
    added: 'Добавлено',
    count: 'Укажите количество стикеров, которое желаете заказать',
    count_ph: 'Количество стикеров',
    hall_ph: 'Зал',
    all_halls: '- Все залы -',
    tables_suffix: 'столов',
    stickers_suffix: 'стикеров',
  },
  stickers_checkout: {
    title: 'Корзина',
    contacts: 'Контакты',
    order: 'Заказ',
    fullname_ph: 'ФИО получателя',
    firstname_ph: 'Имя',
    lastname_ph: 'Фамилия',
    middlename_ph: 'Отчество',
    phone_ph: 'Номер телефона',
    delivery_ph: 'Выберите способ доставки',
    novaposhta: 'В отделении "Новой Почты"',
    warehouse: 'Отделение Новой Почты',
    language: 'Язык стикеров',
    address: 'Адрес',
    courier: `Курьером`,
    comment: 'Комментарий к заказу',
    pay: 'Оплатить заказ',
    total: 'Всего',

    direct_title: 'Обычный QR-код',

    col_design: 'Дизайн',
    col_language: 'Язык',
    col_hall: 'Зал',
    col_table: 'Стол',
    col_count: 'Количество стикеров',
    col_count_sub: 'Для одного стола',
    col_price: 'Стоимость',

    pay_hint: 'Ваш заказ будет отправлен на печать после полной оплаты',
  },
  shipments_table: {
    statuses: {
      preparing: 'Нa печати',
      shipping: 'В пути',
      returned: 'Возвращен',
      shipped: 'Выполнен',
    },
    recipient: 'Получатель',
    delivery: 'Адрес доставки',
    contents: 'Заказ',
  },
  cafe_fill_profile: {
    comment:
      'Чтобы максимально эффективно использовать все возможности QRWaiter, настройте следующие функции:',

    params: {
      contacts: 'Контакты заведения в меню',
      online_payment: 'Онлайн оплата',
      translations: 'Переводы в меню',
      photos: 'Фото на всех блюдах',
      descriptions: 'Описание блюд',
    },

    filled_at: 'Профиль заведения заполнен на',
  },
  onboarding: {
    welcome: 'Спасибо, что выбрали QRWaiter!',
    get_started:
      'Для начала работы Вам нужно ввести общую информацию о Вашем заведении',

    step_1:
      'Загрузите логотип, укажите название и краткое описание Вашего заведения. Также укажите Вашу политику цен.',

    next: 'Далее',
    back: 'Назад',

    name_ph: 'Название заведения',
    desc_ph: 'Описание заведения',
    price_ph: 'Ценовая политика',
    type_ph: 'Тип заведения',
    type_cafe: 'Заклад громадського харчування (кафе, ресторан, фудтрак)',
    type_hotel: 'Готель',

    step_2_comment:
      'Укажите улицу, номер дома, город. Вы также можете указать точное расположение на карте.',
    step_2: 'Теперь укажите адрес заведения',

    address_ph: 'Адрес',

    step_3_comment: 'Укажите в какие дни работает Ваше заведение',
    step_3: 'График работы заведения',

    step_4: 'Почти готово!',
    step_4_comment:
      'Осталось только выбрать валюту, часовой пояс и язык для уведомлений.',
    step_4_hint: 'Уведомления для гостей, персонала и администратора.',

    done: 'Отлично!',
    done_comment:
      'Теперь Ваше заведение готово к работе! Выбирайте нужные системы, настраивайте их и увеличивайте количество заказов в разы!',

    finish: 'Выбрать системы',
  },
  subscribe_period: {
    title: 'Выберите период подписки',
    period: 'ПЕРИОД',
    month: 'месяц | месяцев',
    price: 'СТОИМОСТЬ 1 МЕСЯЦА',
    total: 'К ОПЛАТЕ',
    profit: 'ВЫГОДА',
    pay: 'Оплатить',
  },
  delivery_courier_delay: {
    title: `Напоминание про вызов курьера`,
    desc: `Включите эту опцию, чтобы персонал заранее получал уведомления про необходимость вызова курьера или вызова машины для доставок.`,
    ph: '0 мин',
    desc_on:
      'Укажите, за сколько минут до отправки заказа отправлять уведомление про вызов курьера',
  },
  waiter_schedule: {
    title: 'Отправлять уведомления о заказе',
    tab_always: 'Всегда',
    tab_schedule: 'По расписанию',
    day_noun: '{n}-й день',
    workday: 'Рабочий',
    freeday: 'Выходной',
    add_btn: 'Добавить день',
    desc_on:
      'Укажите порядок смены сотрудника. Если сотрудник работает каждый второй день, достаточно будет добавить 2 дня и указать второй день как "рабочий", тогда система автоматически спланирует его смену на каждый второй день.',
    desc_off:
      'Настройте график работы сотрудника, чтобы уведомления о новых заказах ему приходили только в рабочие дни',
    start_date: 'Дата начала работы:',
  },
  security_panel: {
    title: 'Безопасность',
    phone: 'Проверять номера телефонов гостей с помощью SMS',
  },
  loyalty_view: {
    placeholder: 'Укажите размер бонуса',
    desc:
      'Программа лояльности для Ваших гостей. Вы можете начислять от 1 до 5 процентов бонусов от суммы каждого заказа. Клиент сможет за эти бонусы оплатить за заказ, только в случае если сумма заказа будет меньше баланса бонусов этого же клиента.',
    stats: 'Статистика',
    bonuses_total: 'Бонусов накоплено',
    bonuses_used: 'Бонусов использовано',
  },
  campaigns_view: {
    title: 'Рекламная кампания',
    add_btn: 'Добавить рекламную кампанию',
    desc:
      'Создавайте ссылки для разных рекламных кампаний и отслеживайте их эффективность',
  },
  campaign_card: {
    status: 'Статус:',
    active: 'Активная',
    not_active: 'Неактивная',
    period: 'Срок действия:',
    link: 'Ссылка:',
    download_qr: 'Загрузить QR-код ссылки',

    stat_visits: 'Всего переходов',
    stat_unique: 'Уникальных пользователей',
    stat_orders: 'Заказов',
    stat_sum: 'Сумма заказов',
  },
  add_campaign: {
    title: 'Создание новой кампании',
    name_ph: 'Название рекламной кампании',
    start_ph: 'Дата начала',
    end_ph: 'Дата конца',

    cancel: 'Отменить',
    confirm: 'Создать',
  },
  promocode_add_modal: {
    show_btn: 'Сгенерировать промокод',

    title: 'Генерация промокода',

    max_limit: 'Максимальное количество использований для 1 клиента',

    tab_single: 'Один многоразовый',
    tab_multi: 'Несколько одноразовых',
    count_ph: 'Количество кодов',
    custom_ph: 'Промокод (оставьте пустым чтобы сгенерировать автоматически)',
    type_ph: 'Тип промокода',
    discount_ph: 'Скидка (%)',
  },
  promocode_types: {
    dish_discount: 'Скидка на блюдо',
    check_discount: 'Скидка',
    free_delivery: 'Бесплатная доставка (DELIVERY)',
  },
  promocode_group_card: {
    used_count: 'Количество использований',
    copy_btn: 'Скопировать промокод',
    view_btn: 'Посмотреть промокоды',
    count_ph: 'Количество промокодов',
    code_ph: 'Промокод',

    delete_confirm: `Вы уверены, что хотите удалить этот промокод?`,
  },
  promocodes_table: {
    title: 'Список промокодов',
    col_code: 'Код',
    col_name: 'Имя клиента',
    col_phone: 'Телефон клиента',
    col_status: 'Статус',
    status_used: 'Использован',
    status_not_used: 'Не использован',
    col_date: 'Дата использования',
    export_btn: 'Экспорт',
  },
  demo_qrcode: {
    title: 'Демо-режим',
    title_normal: 'Онлайн меню',
    text:
      'Отсканируйте этот QR-код, чтобы просмотреть меню и сделать тестовый заказ.',
  },
  stats_summary: {
    guests: 'Количество гостей',
    orders: 'Количество заказов',
    average: 'Средний чек',
    income: 'Доход',
  },
  stats_chart: {
    title: 'Заказы',
    conversion: 'Конверсия',
    day: 'День',
    week: 'Неделя',
    month: 'Месяц',
    label_orders: 'Количество заказов',
    label_views: 'Количество переходов',
    label_bounce: 'Конверсия (%)',
  },
  stats_histogram: {
    orders_title: 'Среднее количество заказов',
    hour: 'По часам',
    day: 'По дням',
    average_title: 'Средний чек',
    guests_title: 'Среднее количество гостей',
    finances_title: 'Средний показатель прибыли',

    menus: 'По меню',
    sections: 'По залам',
  },
  stats_income_sources: {
    title: 'Структура дохода',
    by_system: 'Системы',
    by_menu: 'Меню',
    by_waiter: 'Официанты',
    by_halls: 'Залы',
  },
  stats_top_guests: {
    title: 'Топ 10-гостей',
    col_name: 'Клиент',
    col_orders: 'Заказов',
    btn_all: 'Просмотреть список клиентов',
  },
  stats_circle: {
    total: 'ВСЕГО',
    accepted: 'ПРИНЯТО',
    cancelled: 'ОТМЕНЕНО',
  },
  stats_paymethods: {
    title: 'Способ оплаты',
  },
  stats_ratios: {
    title: 'Соотношения по системам',
  },
  alerts: {
    file_too_large:
      'Выбранный файл слишком большой. Максимальний размер файла: 15 МБ',
  },
  dish_photo_editor: {
    title: 'Редактор фото',
    hint:
      'Отредактируйте фото всех форматов так, чтобы не было видно серого фона.',
    button_change: 'ИЗМЕНИТЬ',
    button_rotate: 'ПОВЕРНУТЬ',
    button_auto: 'АВТО',

    button_save: 'СОХРАНИТЬ',

    formats: 'Форматы',
    format_1: '1х1 (карточка блюда)',
    format_2: '16х9 (карточка блюда)',
    format_3: '4х1 (фоновое изображение)',

    cancel: 'Отменить',
    process: 'Сохранить',
  },
  add_discount: {
    btn: 'Добавить акцию',
    title: 'Создание промоакции',
    all_categories: '- все категории -',
    all_products: '- все блюда -',
    all_modificators: '- все модификаторы -',
    all_menus: '- все меню -',
    discount_ph: 'Скидка (%)',
  },
  discount_card: {
    delete_btn: 'Удалить промоакцию',
    period: 'Период:',
    period_from: 'з {start}',
    period_to: 'по {end}',

    applies_to_menu: 'Применяется на меню {menu}',
    applies_to_category: 'категорию {category}',
    applies_to_product: 'блюдо {product}',

    size: 'Размер:',
    title: 'Скидка',
    conditions: 'Условия:',
  },
  tables_grid: {
    heatmap: 'Тепловая карта столов',
    add_table: 'Добавить стол',

    avg_orders: 'Среднее количетсво заказов в день',
    avg_sum: 'Средний чек в день',
    avg_guests: 'Среднее количество гостей в день',
  },
  notification_toast: {
    error: 'Ошибка',
    info: 'Информация',
    support: 'Тех. поддержка',

    confirm: {
      copied: 'Скопировано',
      saved: 'Изменения сохранены',
    },
  },
  client_profile: {
    general_title: 'Общая информация',
    phone: 'Телефон:',
    address: 'Адрес:',

    bonuses_title: 'Накопление бонусов',
    bonuses_desc: 'Вы можете включить постоянное накопление бонусов для гостя',

    discount_title: 'Постоянная скидка',
    discount_desc: 'Вы можете установить постоянную скидку для этого гостя',

    summary_title: 'Общая статистика',
    summary_average: 'Средний чек',
    summary_total: 'Заказов на сумму',
    summary_orders: 'Всего заказов',
    summary_bonuses: 'Бонусный баланс',
    summary_period: 'Периодичность заказов',

    summary_top_dishes: 'ТОП-3 блюд:',
  },
  reminder_timeout_panel: {
    title: 'Уведомление о непринятом заказе',
    comment:
      'Вы можете получать уведомление когда персонал долго не принимает заказ',
  },
  auto_cancel_panel: {
    title: 'Автоматическая отмена заказа',
    comment:
      'Укажите время (в минутах) через которое заказ будет отменен автоматически, если персонал на него не реагирует. Гостю также придет уведомление о том что его заказ не был принят вовремя.',
  },
  preorder_time_flag: {
    title: 'Заказ наперед',
    desc:
      'С этой опцией гости смогут заказать на несколько дней наперед. Иначе же, если опция отключена, все заказы можно будет сделать только указав время "как можно скорее"',
  },
  poster_pending_changes: {
    title: 'Доступны новые изменения',
    desc:
      'Мы зафикисровали изменения в Poster. Выберите, какие из них следует принять, либо проигнорируйте их.',

    new_product_suffix: 'новое блюдо',
    new_price_group_suffix: 'новая группа модификаторов',
    new_price_group_item_suffix: 'новый модификатор',
    remove_price_group_suffix: 'удалено группу модификаторов',

    ignore_btn: 'Игнорировать',
    accept_btn: 'Принять',
  },
  danger_confirm_modal: {
    default_confirm: 'Подтвердить',
    default_cancel: 'Отменить',
    default_title: 'Подтверждение',
  },
  info_modal: {
    default_title: 'Информация',
  },
  orders_panel_download: {
    title: 'Загрузите приложение для приема заказов',
    id_hint: 'ID заведения:',

    web_hint:
      'Панель заказов, которая работает через веб-браузер на компьютере, планшете и смартфоне',
    telegram_hint: 'Настраивается в профиле каждого сотрудника',

    btn_copy: 'Копировать ссылку',
    btn_qr: 'Показать QR-код',
    btn_open: 'Открыть',
    btn_setup: 'Настроить',
    btn_download: 'Скачать',
  },
  integrations_market: {
    categories: {
      pos_systems: 'POS системы',
      payment_gateways: 'Платежные системы',
      menu: 'Меню',
      delivery_partners: 'Доставка',
      analytics: 'Маркетинг и аналитика',
    },
    page: {
      about: 'Описание',
      screenshots: 'Скриншоты',
      contacts: 'Контакты',

      connect: 'Подключить',
      connected: 'Подключено',
      disconnect: 'Отключить',
    },
    editor: {
      edit: 'Редактирование',
      save: 'Сохранить изменения',

      name_ph: 'Название интеграции',
      short_ph: 'Краткое описание',
      desc_ph: 'Описание',
      price_hint: 'Укажите стоимость интеграции',
    },
  },
  mobile_blocker: {
    title: 'Панель администратора недоступна на мобильных устройствах.',
    desc: `Пожалуйста, откройте панель администратора на Вашем компьютере.`,
  },
  quickstart_score: {
    desc: 'Ваш рейтинг использования QRWaiter',
  },
  quickstart_static: {
    title: 'Панда Кью от QRWaiter:',
    pt1: 'Почти готово!',
    pt2: 'Продолжайте настройку чтобы получить максимум от QRWaiter',
  },
  quickstart_options: {
    digital_menu: 'Цифровое меню для заказа внутри заведения',
    online_pay_inside: 'Онлайн оплата заказов в заведении',
    waiter_call: 'Альтернатива кнопки вызова официанта',
    takeaway: 'Система для приема заказов "с собой"',
    pager_alt: 'Альтернатива "пейджерам" на фуд корте',
    custom_delivery: 'Организация собственной доставки',
    phone_alt: 'Альтернатива заказов "по телефону"',
    reservations: 'Бронь столов',
    kiosk: 'Цифровое меню в режиме просмотра без возможности заказа',
  },
  quickstart_survey: {
    title: 'Подбор систем QRWaiter',
    done: 'Готово',

    steps: '2 шага',
    eta: 'около 2 минут',

    motd: 'Определите, какие системы лучше всего подойдут Вам',
    start_btn: 'Пройти опрос',
    skip_btn: 'Отметить как сделано',

    select: 'Выберите задачи, которые Вы бы хотели решить с помощью QRWaiter:',

    confirm_btn: 'Подтвердить',
    connect_btn: 'Подключить нужные системы',

    last_comment: 'После подключения систем, Вам нужно будет их настроить',
  },
  quickstart_setup: {
    setup_btn: 'Настроить',
    pending: 'Выполните все шаги чтобы система заработала',
    ready: 'Система <span class="bold">{system}</span> готова к использованию',
  },
  regular_report: {
    title: 'Регулярный отчет',
    desc: 'Вы можете получать регулярные отчеты по деятельности заведения',

    select_period: 'Выберите периодичность отчета',

    daily: 'Ежедневно',
    weekly: 'Еженедельно',
    monthly: 'Ежемесячно',

    select_channel: 'Выберите куда Вы хотите получать отчет',
    channel_telegram: 'Telegram (Business bot)',
    channel_email: 'Электронная почта',
  },
  password_scores: {
    0: 'Очень слабый пароль 🤕',
    1: 'Слабый пароль 🤕',
    2: 'Достаточно сильный пароль 💪',
    3: 'Сильный пароль 💪',
    4: 'Этот пароль невозможно подобрать 🤖',
  },
  register: {
    title: 'Регистрация',
    name_ph: 'Ваше имя',
    email_ph: 'Электронная почта',
    phone_ph: 'Номер телефона',
    cafe_ph: 'Название заведения',
    address_ph: 'Адрес заведения',

    mail_sent:
      'На адрес <span class="bold">{email}</span> было отправлено письмо с подтверждением регистрации.',
    change_mail: 'Изменить почту',

    action: 'Зарегистрироваться',

    or: 'или',

    via_poster: 'Зарегистрироваться через Poster',

    terms_agree:
      'Я ознакомился и согласен с Политикой конфиденциальности и Условиями использования',
  },
  password_recovery: {
    title: 'Восстановление доступа',

    restore_btn: 'Восстановить пароль',
    back_btn: 'Назад',

    sent_mail:
      'Письмо с дальнейшими указаниями было отправлено на указанную электронную почту',
  },
  tax_selector: {
    title: 'Налог',
    no_tax: '- не применять налог -',
    use_parent: 'применять налог меню',
    menu_comment: 'Вы можете применить налог к этому меню',
    comment: 'Вы можете применить налог к этому блюду',
  },
  taxes: {
    col_name: 'Название',
    col_percent: 'Процент',
    col_type: 'Тип',

    type_none: 'Без налога',
    type_sales: 'На оборот',
    type_vat: 'НДС',

    formula_hint: 'Формула расчета:',

    formula_sales: 'Налог с оборота = Цена блюда * Процент налога',
    formula_vat: 'Цена с НДС = Цена блюда + (Цена блюда * Процент налога)',

    save_btn: 'Сохранить',

    add_tax: 'Добавить налог',

    confirm_delete: 'Вы уверены, что хотите удалить этот налог?',
  },
  poster_missing_dishes: {
    title: 'Обратите внимание',
    text:
      'Некоторые блюда в этом меню не имеют соотвествующей привязанной тех. карты из системы Poster',
    view: 'Посмотреть',
  },
  order_status_notification: {
    title: 'Уведомления по статусу заказа',
    subtitle: 'Отправляйте гостям уведомления по заказу',

    push_title: 'Push-уведомления',
    push_desc:
      'Этот тип уведомлений бесплатен и будет работать только если у пользователя установлено приложение QRWaiter. Если у пользователя нет приложения, уведомления он не получит.',

    sms_title: 'SMS-уведомления',
    sms_desc:
      'Это платный тип уведомлений и он будет использоваться только если у пользователя нет установленного приложения QRWaiter',
  },
  current_balance: {
    title: 'Текущий баланс',
    amount_ph: 'Введите сумму',
    btn_topup: 'Пополнить',
  },
  sms_pricing_terms: {
    title: 'Ценовая политика',
    desc:
      'Стоимость одной SMS зависит от региона номера телефона пользователя. Вы можете просмотреть стоимость SMS для каждого региона в таблице ниже',
    price: 'Цена 1 SMS',
    region: 'Регион',
  },
  balance_table: {
    col_date: 'Дата',
    col_time: 'Время',
    col_category: 'Категория',
    col_description: 'Описание',
    col_amount: 'Сума',
    col_balance: 'Баланс',

    recent: 'Последние транзакции',
    btn_see_all: 'просмотреть историю транзакций',

    categories: {
      sms: 'SMS',
      balance_topup: 'Пополнение баланса',
      marketplace_order: 'Заказ Marketplace',
    },

    sms_types: {
      order_notification: 'Уведомление о статусе заказа',
      phone_authorization: 'Авторизация клиента',
      security_alert: 'Уведомление безопасности',
    },

    outcome_stats: 'Статистика расходов',
  },
  sms_categories: {
    title: 'Категории SMS',
    active: 'Актвино',
    inactive: 'Неактивно',

    order_status: 'Уведомления о статусе заказа',
    customer_verify: 'Верификация клиента по номеру телефона',
    pending_orders: 'Уведомления о непринятых заказах',
    security: 'Уведомления безопасности',
    marketing: 'Маркетинговые рассылки',

    btn_setup: 'Настроить',
  },
  nomenculature_packaging: {
    btn_add: 'Добавить упаковку',

    col_name: 'Название',
    col_price: 'Цена',
    col_weight: 'Максимальный вес',
    col_tax: 'Налог',
    col_volume: 'Объем',
    // col_free_limit: '',

    param_pos_id: 'Соотвествующий элемент номенкулатуры в POS системе',

    btn_save: 'Сохранить',
    confirm_remove: 'Вы уверены что хотите удалить эту упаковку?',
  },
  packaging_attachment: {
    no_default: '- без упаковки -',
    default_title: 'Упаковка по-умолчанию',
    price_hint: 'Цена: {price} {currency} | Налог: {tax}%',

    custom_btn: 'Добавить нестандартную упаковку',
  },
  add_custom_package: {
    title: 'Нестандартная упаковка',
    subtitle: 'Выберите конфигурацию блюда и укажите упаковку для нее',

    price: 'Цена',
    total_weight: 'Вес',

    name_ph: 'Название для нестандартной упаковки',
    package_ph: 'Выберите упаковку',
    btn_add: 'Добавить нестандартную упаковку',

    combination_exists: 'Выбранная конфигурация модификаторов уже существует',
  },
  sms_history: {
    btn_open: 'Просмотреть историю SMS',

    col_date: 'Дата',
    col_time: 'Время',
    col_type: 'Тип',
    col_text: 'Текст',
    col_segments: 'Сегменты',
    col_receiver: 'Получатель',
    col_cost: 'Стоимость',
    col_balance: 'Баланс',
  },
  client_authorization: {
    title: 'Авторизация номера телефона клиента через SMS',
    subtitle: 'Мы отправим уникальный код клиенту для проверки номера телефона',

    text1:
      'Это платная функция. Стоимость каждой SMS будет списана с Вашего баланса автоматически.',
    text2:
      'Мы используем метод смарт-верификации - система запоминает устройство с которого был подтвержден номер телефона, что позволяет уменьшить общее количество SMS.',
  },
  system_card: {
    active: 'Активная',
    inactive: 'Неактивная',
  },
  subscription_status_panel: {
    motto_inside: 'Система для заказов внутри заведения',
    motto_preorder: 'Система для заказов с собой и на вынос',
    motto_delivery: 'Система для заказов с доставкой',
    motto_reserve: 'Система для бронирования столов',
    motto_preview: 'Система для цифрового меню в режиме витрины',

    promo_title: 'Приветствуем!',
    promo_text: 'Вам доступны 14 дней пробного периода для системы',
    promo_warn:
      'Обратите внимание, что после начала пробного периода если нельзя будет остановить',

    btn_trial: 'Начать пробный период',
    btn_subscribe: 'Оформить подписку',
    btn_cancel: 'Отменить подписку',
    btn_cancel_approval: 'Отменить подтверждение карты',
    btn_change_card: 'Сменить карту',
    btn_view_invoices: 'Просмотреть счета',
    btn_renew: 'Возобновить подписку',

    param_subscription: 'Подписка',
    param_status: 'Статус подписки',
    param_trial: 'Пробный период',
    param_paid: 'Отменена',
    param_card: 'Подключенная карта',
    param_date: 'Дата оплаты',

    period_year: 'Ежегодная',
    period_month: 'Ежемесячная',

    paid_period: 'Оплачена | до ',

    status_approval: 'Ожидаем подтверждения от банка',
    trial_end: 'Закончился',

    days_left: 'дн. осталось',

    desc_trial:
      'После завершения пробного периода Вам нужно будет оформить попдиску, чтобы продолжить использование системы ',
    desc_trial_end:
      'Ваш пробный период закончился. Оформите подписку чобы продолжить пользоваться системой',
    desc_approval:
      'Ваша система будет активна после того как мы обработаем Ваш платеж',
    desc_active: '* Списание средств произойдет автоматически',
    desc_paid:
      'Ваша подписка была отменена, но Вы все еще можете использовать систему {system} до конца оплаченного периода',
    desc_failed:
      'Провести Ваш платеж нам не удалось. Мы сделаем еще 3 попытки списания (по разу в день). В ином случае, Ваша подписка будет отменена.',

    feedback_text:
      'Мы будем благодарны, если Вы оставите отзыв о Вашем опыте использования QRWaiter',
    feedback_btn: 'Оставить отзыв',

    ended_title: 'Закончилась',

    ended_thanks: 'Спасибо!',
    ended_subtitle: 'Мы были рады работать с Вами!',

    failed_attempt_1: '1-ая попытка оплаты',
    failed_attempt_2: '2-ая попытка оплаты',
    failed_attempt_3: '3-ая попытка оплаты',
    failed_attempt_4: '4-ая попытка оплаты',

    charge_later:
      'Если Вы оформите подписку сейчас, первое списание средств произойдет по окончанию бесплатного периода',
  },
  pos_sync_tooltip: {
    title: 'Синхронизация',

    btn_sync: 'Синхронизировать',

    manual_sync: 'Ручная синхронизация',
    manual_sync_desc:
      'Вы можете принудительно синхронизировать Ваше меню с POS-системой',
    manual_done: 'Готово',

    menu_sync: 'Авто-синхронизация',
    menu_sync_desc:
      'Система будет проверять изменения в POS-системе и автоматически применять их к меню.',
    storage_sync: 'Остатки на складе',
    storage_sync_desc:
      'Вы можете синхронизировать меню с остатками на складе. Гостю будут показаны только блюда в наличии',
  },
  pos_pending_changes_tooltip: {
    title: 'История изменений',
    tab_new: 'Новые',
    tab_ignored: 'Игнорированы',

    no_changes: 'Все изменения приняты',
    no_changes_sub: 'Никаких действий не требуется',

    type_added: 'Добавлено',

    btn_select_all: 'Выбрать все',
  },
  iqos_actions: {
    save: 'Сохранить',
  },
  pos_storage_leftovers_popup: {
    title: 'Скрытые позиции',

    items_hidden:
      'У Вас есть {count} скрытых блюд в результате синхронизации остатков',
    choose_action: 'Пожалуйста, выберите что Вы хотите с ними сделать',

    btn_hide: 'Оставить скрытыми',
    btn_show: 'Показать в меню',
  },

  checklists: {
    btn_new: 'Новая форма',
    search_ph: 'Поиск...',
    filter_all: 'Все',
    forms_noun: '{n} форма | {n} форм',
    last_edited: 'Последнее редактирование',
    tab_forms: 'Формы',
    tab_reports: 'Отчеты',
  },

  checklist_editor: {
    new_ph: 'Новая форма',
    badge_draft: 'Черновик',
    badge_live: 'Опубликовано',
    badge_edited: 'Изменено',

    tab_content: 'Контент',
    tab_schedule: 'График',
    tab_assign: 'Назначение',

    btn_delete: 'Удалить форму',
    btn_copy: 'Копировать форму',
    btn_save: 'Сохранить изменения',
    btn_publish: 'Опубликовать',
    btn_unpublish: 'Снять с публикации',
    btn_preview: 'Предпросмотр',

    add_tag_ph: 'Добавить тег...',

    title_ph: 'Назвите Вашу форму...',
    desc_ph: 'Опишите Вашу форму...',

    type_scheduled: 'Плановая',
    type_adhoc: 'Постоянная',

    type_scheduled_desc: 'Форма будет доступная по графику',
    type_adhoc_desc: 'Форма будет доступная всегда',

    type_adhoc_content: 'Эта форму можно заполнить в любой момент',

    members_noun: '{n} член команды | {n} членов команды',
    btn_add_schedule: 'Добавить график',
    schedules_noun: '{n} график | {n} графика',

    btn_add_member: 'Добавить члена команды',

    team_search_ph: 'Поиск в команде...',
    assign_ph: 'Назначить члена команды',

    copied: 'Форма скопирована. Вы теперь редактируете новую копию',

    delete_title:
      'Вы уверены, что хотите <div class="del">удалить</div> форму?',
    delete_subtitle: 'Вся информация будет утрачена.',
    delete_cancel: 'Отмена',
    delete_confirm: 'Удалить форму',

    save_title: 'Ви желаете сохранить изменения?',
    save_subtitle: 'Иначе изменения будут утеряны.',
    save_cancel: 'Не сохранять',
    save_confirm: 'Сохранить',
  },
  checklist_blocks: {
    title_ph: 'Название',
    text: {
      btn_save: 'Сохранить',
    },
    input: {
      title: 'Текстовое поле',
      ph: '',
    },
    file: {
      title: 'Прикрепление файла',
    },
    options: {
      title: 'Опции',
      item_ph: 'Опция',
      btn_add: 'Добавить опцию',
      display_as: 'Показывать как',
      as_dropdown: 'Выпадающий список',
      as_buttons: 'Кнопки',
      score_ph: 'Баллы',
    },
    checklist: {
      title: 'Чек-лист',
      btn_add: 'Добавить пункт',
      item_ph: 'Пункты чеклиста',

      setting_required: 'Все пункты этого чеклиста должны быть выполнены',
      setting_comment:
        'Требовать комментарий при обозначении пункта как невыполненный',
      setting_addable: 'Дать возможность пользователям добавлять свои пункты',
    },
    number: {
      title: 'Числовое поле',
      subtitle: 'Для ввода денежных сум, массы, температуры...',
      prefix_title: 'Префикс / суфикс',
      prefix_desc: 'Вы можете добавить символы до и после числа',
      number_ph: 'Число',
      prefix_ph: 'Префикс',
      suffix_ph: 'Суфикс',

      range_title: 'Допустимые значения',
      range_desc:
        'Вы можете указать минимальное и максимальное значения для этого поля',
      range_min: 'Мин',
      range_max: 'Макс',
    },
    settings: {
      required: `Обьязательно`,
      required_desc: `Для отправки формы все обязательные секции должны быть выполнены`,

      scores: 'Баллы',
      scores_desc: 'Укажите стоимость каждой опции в баллах',

      cached: 'Сохранять последнее значение',

      assign_title: 'Связать с опцией',
      assign_add: 'Добавить опцию',
      assign_search: 'Поиск опций',
    },
  },
  checklist_schedule: {
    type_scheduled: 'Плановая',
    type_repeat: 'Повтор',

    from: 'С',
    to: 'до',

    start_date: 'Дата',
    start_time: 'Время начала',
    end_time: 'Время окончания',

    repeatable: 'Повторять',
    repeat_every: 'Повторять каждые',

    save: 'Сохранить',

    day: 'День',
    week: 'Неделю',
    month: 'Месяц',
    year: 'Год',

    weekday_names: ['Пн', 'Вт', 'Ср', 'Чт', 'Пт', 'Сб', 'Нд'],
    month_names: [
      'січень',
      'лютий',
      'березень',
      'квітень',
      'травень',
      'червень',
      'липень',
      'серпень',
      'вересень',
      'жовтень',
      'листопад',
      'грудень',
    ],
  },
  checklist_report_blocks: {
    required: `Обязательно`,
    value_ph: 'Значение',
    score: 'Очки',
    completed: 'Выполнено',
    uncompleted: 'Не выполнено',
    not_applicable: 'Не применимо',

    no_file: 'Файл не загружен',
  },
  checklist_reports: {
    completeness: 'Выполнено',
    scheduled: 'Плановая',
    expired: 'Просроченая',
    total_score: 'Всего баллов',
    report_time: 'Время отчета',
    none_score: 'Нет',

    checklist_stats: 'Выполненные чеклисты',

    completeness_hint:
      'Рассчитывается на основне количества обьязательных блоков',

    empty_title: 'Отчетов не найдено',
    empty_subtitle: 'за указанными датами',
  },
  reserve_deposit_settings: {
    title: 'Депозит бронирования',
    subtitle:
      'Ваши гости должны будуть оплатить депозит для подтверждения брони',
    mode_full: 'Полная цена забронированных услуг',
    mode_constant: 'Фиксированная цена',
    mode_percent: 'Процент от стоимости выбранных услуг',
  },
  phone_confirmation_panel: {
    title: 'Подтверждение телефона',
    subtitle: 'Мы будем проверять номер телефона пользователя с помощью SMS',
    warning:
      'Это платная услуга. Перейдите к настройкам SMS чтобы увидеть тарифы.',
    more: 'Детальнее',
  },
  iiko_auto_settings: {
    online_title: 'Автоматически закрывать заказы, оплаченные онлайн',
    online_subtitle:
      'Эта опция будет автоматически закрывать заказы в iiko, если они были оплачены онлайн',

    select_counterparty:
      'Выберите контрагента, на имя которого проводить оплату',
    none: '-- без контрагента --',
  },
  auto_accept: {
    title: 'Автоматический прием заказов',
    subtitle: `Вы можете указать официанта, на имя которого будут автоматически приниматься все заказы`,

    select_ph: '-- выберите официанта --',
  },
  public_beta: {
    title: 'Menu App 2.0',
    desc:
      'Опробуйте свежий, удобный дизайн с плавной навигацией и инновационными функциями. Чтобы попробовать, просто включите эту опцию. Не стесняйтесь делиться отзывами, чтобы помочь нам улучшить взаимодействие. Вы можете вернуться к предыдущему интерфейсу в любое время, отключив эту опцию. Наслаждайтесь изучением нового интерфейса!',
    feedback: 'Будем рады услышать отзывы и предложения по новому интерфейсу.',
    supported_in: 'Сейчас новый интерфейс поддерживается в системах',
  },
  billing_company_details: {
    title: 'Детали компании',
    subtitle:
      'Заполните свои данные, чтобы получать счета за оплату подписки на QRWaiter и юридическое соглашение.',

    type: 'Тип компании',
    name: 'Название компании',
    vat_id: 'Налоговый код компании',
    address: 'Адрес компании',
    delivery_address: 'Адрес доставки документов',

    sp: 'ИП',
    llc: 'ООО',
  },
  billing_reminders_panel: {
    title: 'Напоминания о продлении подписки',
    subtitle:
      'Введите один или несколько адресов электронной почты, чтобы ваш бухгалтер или другие сотрудники также получали напоминание за 3 дня до истечения срока подписки. Если вы оплачиваете подписку банковским переводом, счет на оплату будет отправлен на ваш адрес электронной почты.',

    list: 'Адреса электронной почты для напоминаний',
    add: 'Добавить адрес',
  },
  select_plan_modal: {
    title: 'Тарифный план',
    subtitle: 'Выберите план, который подходит для вашего бизнеса.',
    monthly: 'Ежемесячно',
    annually: 'Ежегодно',
    most_popular: 'САМЫЙ ПОПУЛЯРНЫЙ',

    month: 'месяц',
    year: 'год',

    selected: 'ВЫБРАННЫЙ ПЛАН',
    select: 'ВЫБРАТЬ ПЛАН',

    plan: 'План',

    cancel: 'Отмена',
    confirm: 'Подтвердить',
    summary: 'Суммарно',

    autocancel_hint:
      'Внимание: при изменении тарифного плана Ваш автоплатеж будет отменен. Для восстановления автоматической оплаты за подписку QRWaiter, пожалуйста, оформите автоплатеж снова.',

    lite_desc:
      'План Lite предлагает простое цифровое меню через QR-код или ссылку, идеально подходит для тех, кто нуждается только в основной услуге цифрового меню.',
    dynamic_desc:
      'План Dynamic обеспечивает гибкость, позволяя вам выбирать и оплачивать только те услуги, которые вам необходимы: Inside, Takeaway, Delivery',
    smart_desc:
      'План Smart - это комплексный пакет со всеми четырьмя услугами, предлагаемый по общей стоимости ниже, чем при выборе каждой услуги отдельно в плане Dynamic.',
  },
  pay_invoice_modal: {
    invoice: 'Счет',
    service: 'Услуга',
    period: 'Период',
    subscription: 'Подписка',
    sum: 'Сумма',

    monthly: 'Ежемесячно',
    yearly: 'Ежегодно',
    total: 'Всего',
    payment_type: 'Способ оплаты',
    by_card: 'Оплатить картой',
    by_bank: 'Банковский перевод',

    auto_payment: 'Автоплатеж',
    ap_hint:
      'Сумма будет автоматически списываться с вашей карты каждый платежный цикл',

    pay_now: 'Оплатить сейчас',

    recipient: 'Получатель',

    bank: 'Банк',
    payment_description: 'Описание платежа',
    description_ph: 'Оплата за счет',
    warning:
      'Пожалуйста, укажите точное описание платежа, чтобы наша система могла автоматически распознать оплату. Аккаунт будет активирован после получения платежа.',
  },
  superbilling: {
    tab_plan: 'План',
    tab_details: 'Детали и уведомления',

    valid_till: 'Заведение действительно до',
    pricing_plan: 'Тарифный план',
    payment_sum: 'Сумма платежа',
    every_month: 'Каждый месяц',
    every_year: 'Каждый год',

    free_period: 'Бесплатный период',

    services_noun: 'услуга | услуги',
    calendar_day: '-й календарный день',

    invoices: 'Счета',

    invoice_id: 'Номер счета',
    due_date: 'Дата оплаты',
    services: 'Услуги',
    sum: 'Сумма',
    payment_method: 'Способ оплаты',
    status: 'Статус',

    paid: 'Оплачено',
    unpaid: 'Не оплачено',
    refunded: 'Возвращено',

    card: 'Карта',
    bank_transfer: 'Банковский перевод',

    pay_invoice: 'Оплатить',

    change_plan: 'Сменить тарифный план',

    auto_payment: 'Автоплатеж',
    ap_status: 'Статус',
    ap_enabled: 'Включено',
    ap_disable: 'Отключить',
    ap_card: 'Привязанная карта',
    ap_change: 'Изменить',
    ap_next_payment: 'Следующий платеж',
    ap_attempt: '-я попытка оплаты',
    ap_more: 'Подробнее',
    ap_less: 'Скрыть',
    ap_warning:
      'Если первая попытка оплаты неудачна, мы будем делать еще 3 попытки (по одной в день). Если все четыре попытки не удаются, автоплатеж будет отменен.',

    empty_hint: 'Выберите правильный план для вашего бизнеса',
    empty_select: 'Выбрать план',

    confirm_disable: 'Вы уверены что хотите отменить авто-платеж?',

    next_payment: 'Следующий платеж',
  },
  superbilling_system_card: {
    active: 'Активно',
    inactive: 'Неактивно',

    banner_title: 'Обновите Ваш тарифный план',
    banner_text:
      'Ваш текущий план не включает эту систему. Вам необходимо обновить тарифный план чтобы включить ее.',
    banner_btn: 'Обновить план',

    checklist_title: 'Чек-лист настройки',
    checklist_hint: 'Завершите этот чек-лист, чтобы система заработала',
  },
  failed_payment_banner: {
    text: 'Оплата не удалась. Пожалуйста, обновите ваши платежные данные',
    btn: 'Обновить реквизитыs',
  },
  disable_system_modal: {
    title: 'Отключение системы',
    question: 'Как вы хотите включить систему в следующий раз?',
    mode_manual: 'Вручную',
    mode_auto: 'Автоматически в выбранную дату',

    auto_date: 'Когда система должна включится автоматически?',

    hint_manual: 'Система будет отключена, пока вы не включите ее вручную',
    hint_auto: 'Система автоматически включится в',

    confirm_btn: 'Подтвердить',

    preliminary_title: 'Предварительные заказы, пока система выключена',
    preliminary_desc:
      'Ваши гости смогут делать предварительные заказы на время, когда система будет снова доступна. Таким образом, вы можете собирать предварительные заказы заранее.',
  },
  tips_settings: {
    title: 'Чаевые',
    subtitle: 'Функция, которая будет запрашивать Ваших гостей оставить чаевые',
    turn_on: 'Включить',
    turn_off: 'Отключить',
  },
  tips_mode_panel: {
    title: 'Режим чаевых',
    subtitle: 'Выберите, как Вы хотите, чтобы работала эта функция',

    option_corporate: 'Корпоративные',
    option_corporate_desc:
      'Чаевые будут добавлены к сумме заказа и будут оплачены на Ваш счет вместе с чеком заказа',

    option_personal: 'Персональные',
    option_personal_desc:
      'Гости будут оставлять чаевые самостоятельно, выбирая кого-то из Вашего персонала. Чаевые будут отправлены официанту напрямую с помощью ссылки.',
  },
  tips_merchant_panel: {
    title: 'Платежный счет',
    subtitle: 'Пожалуйста, выберите на какой счет следует зачислять чаевые',
  },
  tips_systems_panel: {
    title: 'Системы',
    subtitle: 'Вы можете выбрать системы, в которых чаевые будут работать',
  },
  tips_team_panel: {
    title: 'Команда',
    subtitle:
      'Настройте чаевые для каждого члена Вашей команды, указав ссылку для оставления чаевых.',
    link: 'Ссылка',
    role_ph: 'Официант',
  },
  request_integration: {
    btn: 'Запросить интеграцию',
    description:
      'Если Вы не нашли нужную Вам интеграцию, Вы можете отправить свой запрос на на ее разработку. Интеграции, на которые мы получаем большое количество запросов - имеют приоритет в разработке и будут доступны как можно быстрее.',
    name_ph: 'Название интеграции',
    send: 'Отправить',
    success: 'Ваш запрос на интеграцию успешно отправлен',
  },
  delivery_tariffs: {
    title: 'Цена доставки',
    subtitle: 'Настройте условия для расчета стоимости доставки',

    type_free: 'Бесплатная',
    type_paid: 'Платная',

    mode_title: 'Режим тарификации',
    mode_custom: 'Собственный',
    mode_partner: 'Партнер по доставке',

    tariff: 'Тариф',
    prop_name: 'Название',
    prop_price: 'Цена',
    prop_zone: 'Зона',
    name_ph: 'Название тарифа',
    btn_add: 'Добавить',
  },
};
